import {
  Badge,
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  HStack,
  IconButton,
  Image,
  Input,
  Select,
  SimpleGrid,
  Spinner,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
  Textarea,
  useToast,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import axios from "axios";
import { Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  FiDownload,
  FiImage,
  FiPlus,
  FiTrash2,
  FiUpload,
  FiX,
} from "react-icons/fi";
import { useDispatch } from "react-redux";
import {
  REQUEST_CREATE_MASTER_CASESTUDY,
  REQUEST_MASTER_CASESTUDY,
  REQUEST_UPDATE_MASTER_CASESTUDY,
} from "../../store/casestudy/casestudyActionTypes";
import { useCasestudyMaster } from "../../store/casestudy/reducer";
import { UploadVideoAndSelectThumbnail } from "../uploadVideo/UploadVideoAndSelectThumbnail";

interface CasestudyFormDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  bannerData?: any;
  casestudyData?: any;
  refreshData?: () => void;
}

interface Option {
  _id: string;
  name: string;
  [key: string]: any;
}

interface ImageState {
  files: File[];
  previews: string[];
}

const IMAGE_LIMITS = {
  overview: 2,
  designVision: 4,
  userFlow: 1,
  revenue: 1,
  colorPalette: 1,
  wireFrame: 1,
  uiDesign: 1,
  metadata: 1,
  logo: 4,
  typography: 8,
  showcase: 1,
  projectDetails: 6,
  slider: 6,
};

interface BannerImageUploaderProps {
  label: string;
  fieldName: string;
  currentImage: string | undefined | any;
  setFieldValue: (field: string, value: any) => void;
  isVideo?: boolean;
  enforceImageDimensions?: boolean;
  isWatermark?: boolean;
  allowBothTypes?: boolean;
  currentImageForThumbnail?: string | any;
  imageError?: string | any;
  altFieldName?: string;
  currentAlt?: string;
}

// const BannerMediaUploader: React.FC<BannerImageUploaderProps> = ({
//   label,
//   fieldName,
//   currentImage,
//   setFieldValue,
//   isVideo = false,
//   enforceImageDimensions = false,
//   isWatermark = true,
//   allowBothTypes = false,
// }) => {
//   const [isUploading, setIsUploading] = useState(false);
//   const [mediaType, setMediaType] = useState<"image" | "video">(
//     isVideo ? "video" : "image"
//   );
//   const toast = useToast();
//   const REQUIRED_WIDTH = 1098;
//   const REQUIRED_HEIGHT = 702;

//   useEffect(() => {
//     if (currentImage) {
//       const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi"];
//       const isVideoFile = videoExtensions.some((ext) =>
//         currentImage.toLowerCase().includes(ext)
//       );
//       setMediaType(isVideoFile ? "video" : "image");
//     }
//   }, [currentImage]);

//   const checkDimensions = (file: File): Promise<boolean> => {
//     if (!enforceImageDimensions) {
//       return Promise.resolve(true);
//     }

//     return new Promise((resolve) => {
//       if (file.type.startsWith("video/")) {
//         const video = document.createElement("video");
//         video.preload = "metadata";

//         video.onloadedmetadata = () => {
//           URL.revokeObjectURL(video.src);
//           const isCorrectDimension =
//             video.videoWidth === REQUIRED_WIDTH &&
//             video.videoHeight === REQUIRED_HEIGHT;
//           resolve(isCorrectDimension);
//         };

//         video.src = URL.createObjectURL(file);
//       } else {
//         const img = document.createElement("img") as HTMLImageElement;

//         img.onload = () => {
//           URL.revokeObjectURL(img.src);
//           const isCorrectDimension =
//             img.width === REQUIRED_WIDTH && img.height === REQUIRED_HEIGHT;
//           resolve(isCorrectDimension);
//         };

//         img.src = URL.createObjectURL(file);
//       }
//     });
//   };

//   const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = e.target.files;
//     if (!files || files.length === 0) return;

//     setIsUploading(true);

//     try {
//       const file = files[0];
//       const isUploadingVideo = file.type.startsWith("video/");

//       setMediaType(isUploadingVideo ? "video" : "image");

//       const hasCorrectDimensions = await checkDimensions(file);

//       if (!hasCorrectDimensions) {
//         toast({
//           title: `Invalid dimensions`,
//           description: `${
//             isUploadingVideo ? "Video" : "Image"
//           } must be exactly ${REQUIRED_WIDTH}×${REQUIRED_HEIGHT} pixels`,
//           status: "error",
//           duration: 5000,
//           isClosable: true,
//         });
//         setIsUploading(false);
//         e.target.value = "";
//         return;
//       }

//       const formData = new FormData();
//       formData.append("file", file);
//       formData.append("isWatermark", isWatermark ? "true" : "false");

//       const response = await axios.post(
//         `${process.env.REACT_APP_BASE_URL}/admin/image`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       const uploadedUrl = response.data[0].imageURL;
//       setFieldValue(fieldName, uploadedUrl);

//       toast({
//         title: `${isUploadingVideo ? "Video" : "Image"} uploaded successfully`,
//         status: "success",
//         duration: 3000,
//         isClosable: true,
//       });
//     } catch (error) {
//       console.error(`Error uploading media:`, error);
//       toast({
//         title: `Failed to upload media`,
//         description: error instanceof Error ? error.message : "Unknown error",
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     } finally {
//       setIsUploading(false);
//       e.target.value = "";
//     }
//   };

//   const removeMedia = () => {
//     setFieldValue(fieldName, "");
//   };

//   const getAcceptAttribute = () => {
//     if (allowBothTypes) {
//       return "image/*,video/*";
//     }
//     return isVideo ? "video/*" : "image/*";
//   };

//   const isCurrentVideo = allowBothTypes ? mediaType === "video" : isVideo;

//   return (
//     <FormControl>
//       <FormLabel>{label}</FormLabel>
//       <VStack spacing={4} align="stretch">
//         {currentImage && (
//           <Box position="relative" width="100%" maxWidth="300px">
//             <Button
//               size="sm"
//               position="absolute"
//               top={2}
//               right={2}
//               colorScheme="red"
//               onClick={removeMedia}
//               borderRadius="full"
//               zIndex={1}
//               p={0}
//               minW="30px"
//               height="30px"
//             >
//               <FiX />
//             </Button>
//             {isCurrentVideo ? (
//               <video
//                 src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${currentImage}`}
//                 controls
//                 style={{ maxHeight: "200px", width: "100%" }}
//               />
//             ) : (
//               <Image
//                 src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${currentImage}`}
//                 alt={label}
//                 borderRadius="md"
//                 maxH="200px"
//                 objectFit="contain"
//                 width="100%"
//                 border="1px solid"
//                 borderColor="gray.200"
//               />
//             )}
//           </Box>
//         )}

//         {!currentImage && (
//           <Button
//             as="label"
//             htmlFor={`media-upload-${fieldName}`}
//             cursor="pointer"
//             leftIcon={<FiUpload />}
//             colorScheme="blue"
//             variant="outline"
//             isLoading={isUploading}
//             height="100px"
//             borderStyle="dashed"
//           >
//             <Text>
//               {allowBothTypes
//                 ? "Upload Image or Video"
//                 : `Upload ${isVideo ? "Video" : "Image"}`}
//             </Text>
//             <Input
//               id={`media-upload-${fieldName}`}
//               type="file"
//               accept={getAcceptAttribute()}
//               onChange={handleUpload}
//               display="none"
//             />
//           </Button>
//         )}

//         {currentImage && (
//           <Button
//             as="label"
//             htmlFor={`media-upload-${fieldName}`}
//             cursor="pointer"
//             leftIcon={<FiUpload />}
//             colorScheme="blue"
//             variant="outline"
//             isLoading={isUploading}
//             size="sm"
//           >
//             <Text>
//               {allowBothTypes
//                 ? "Replace Media"
//                 : `Replace ${isVideo ? "Video" : "Image"}`}
//             </Text>
//             <Input
//               id={`media-upload-${fieldName}`}
//               type="file"
//               accept={getAcceptAttribute()}
//               onChange={handleUpload}
//               display="none"
//             />
//           </Button>
//         )}
//       </VStack>
//     </FormControl>
//   );
// };

const BannerMediaUploader: React.FC<BannerImageUploaderProps> = ({
  label,
  fieldName,
  currentImage,
  setFieldValue,
  isVideo = false,
  enforceImageDimensions = false,
  isWatermark = true,
  allowBothTypes = false,
  currentImageForThumbnail,
  imageError,
  altFieldName,
  currentAlt = "",
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [thumbnails, setThumbnails] = useState<string[]>([]);
  const [loadingThumbs, setLoadingThumbs] = useState(false);
  const [selectedThumb, setSelectedThumb] = useState<string | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [imageUploaded, setImageUploaded] = useState(false);

  const [mediaType, setMediaType] = useState<"image" | "video">(
    isVideo ? "video" : "image",
  );
  const toast = useToast();
  const REQUIRED_WIDTH = 1098;
  const REQUIRED_HEIGHT = 702;

  useEffect(() => {
    console.log("Current Image:", currentImage);

    if (currentImage) {
      const videoExtensions = [".mp4", ".webm", ".ogg", ".mov", ".avi"];
      const isVideoFile = videoExtensions.some((ext) => {
        if (typeof currentImage === "string") {
          return currentImage.toLowerCase().includes(ext);
        } else if (currentImage && currentImage.url) {
          return currentImage.url.toLowerCase().includes(ext);
        }
        return false;
      });
      setMediaType(isVideoFile ? "video" : "image");
    }
  }, [currentImage]);

  useEffect(() => {
    if (currentImageForThumbnail) {
      // Construct the full URL of the saved thumbnail
      const thumbUrl =
        typeof currentImageForThumbnail === "string"
          ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${currentImageForThumbnail}`
          : `${process.env.REACT_APP_IMAGE_BASE_URL}/${currentImageForThumbnail.url}`;

      // Make it the selected thumbnail
      setSelectedThumb(thumbUrl);

      // Optionally include it in the thumbnails list so it appears in the horizontal scroll
    }
  }, [currentImageForThumbnail]);

  const checkDimensions = (file: File): Promise<boolean> => {
    if (!enforceImageDimensions) {
      return Promise.resolve(true);
    }

    return new Promise((resolve) => {
      if (file.type.startsWith("video/")) {
        const video = document.createElement("video");
        video.preload = "metadata";

        video.onloadedmetadata = () => {
          URL.revokeObjectURL(video.src);
          const isCorrectDimension =
            video.videoWidth === REQUIRED_WIDTH &&
            video.videoHeight === REQUIRED_HEIGHT;
          resolve(isCorrectDimension);
        };

        video.src = URL.createObjectURL(file);
      } else {
        const img = document.createElement("img") as HTMLImageElement;

        img.onload = () => {
          URL.revokeObjectURL(img.src);
          const isCorrectDimension =
            img.width === REQUIRED_WIDTH && img.height === REQUIRED_HEIGHT;
          resolve(isCorrectDimension);
        };

        img.src = URL.createObjectURL(file);
      }
    });
  };

  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    setIsUploading(true);

    try {
      const file = files[0];
      const isUploadingVideo = file.type.startsWith("video/");
      setMediaType(isUploadingVideo ? "video" : "image");

      setUploadedFile(isUploadingVideo ? file : null); // store video file locally for thumbnail generation

      const hasCorrectDimensions = await checkDimensions(file);
      if (!hasCorrectDimensions) {
        toast(/* dimension error message */);
        setIsUploading(false);
        e.target.value = "";
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("isWatermark", isWatermark ? "true" : "false");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/image`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      const uploadedUrl = response.data[0].imageURL;

      if (fieldName === "showcase") {
        setFieldValue("showcase.url", uploadedUrl);
        setFieldValue("showcase.alt", file.name.split(".")[0]);
      } else {
        setFieldValue(fieldName, uploadedUrl);
        if (altFieldName) {
          setFieldValue(altFieldName, file.name.split(".")[0]);
        }
      }

      toast({
        title: `${isUploadingVideo ? "Video" : "Image"} uploaded successfully`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error(`Error uploading media:`, error);
      toast({
        title: `Failed to upload media`,
        description: error instanceof Error ? error.message : "Unknown error",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsUploading(false);
      e.target.value = "";
    }
  };

  const selectThumbnail = (src: string) => {
    setSelectedThumb(src);
    setImageUploaded(false);
  };
  // Modify generateThumbnails to support remote videos on edit
  const generateThumbnails = async () => {
    setLoadingThumbs(true);

    // Determine the source of the video: uploaded file or existing currentImage
    let videoSrc: string | null = null;
    if (uploadedFile) {
      // Use the File object for newly uploaded videos
      videoSrc = URL.createObjectURL(uploadedFile);
    } else if (currentImage) {
      // Build the full URL for the existing video on edit
      const videoPath =
        typeof currentImage === "string"
          ? currentImage
          : currentImage.url || "";

      if (videoPath) {
        videoSrc = `${process.env.REACT_APP_IMAGE_BASE_URL}/${videoPath}`;
      }
    }

    if (!videoSrc) {
      setLoadingThumbs(false);
      return;
    }

    const video = videoRef.current!;
    const canvas = canvasRef.current!;
    const ctx = canvas.getContext("2d")!;
    const thumbs: string[] = [];

    // If the video is remote, consider setting crossOrigin to avoid tainted canvas:contentReference[oaicite:2]{index=2}
    video.crossOrigin = "anonymous";
    video.src = videoSrc;
    video.load();

    video.onloadedmetadata = () => {
      const duration = video.duration;
      const step = 0.5;
      let current = 0;

      const capture = () => {
        video.currentTime = current;
      };

      video.onseeked = () => {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0);
        thumbs.push(canvas.toDataURL());
        current += step;
        if (current <= duration) {
          capture();
        } else {
          setThumbnails(thumbs);
          setSelectedThumb(thumbs[0] || null);
          setLoadingThumbs(false);
          // If we created an object URL from a file, revoke it to free memory
          if (uploadedFile) {
            URL.revokeObjectURL(videoSrc!);
          }
        }
      };
      capture();
    };
  };

  const handleUploadThumbnail = async (src: string) => {
    if (!src) return;
    setIsUploading(true);
    try {
      const blob = await fetch(src).then((res) => res.blob());
      console.log("xxxcurrentImage:", currentImage);

      const urlPath =
        typeof currentImage === "string"
          ? currentImage
          : currentImage.url || currentImage.thumbUrl || "";
      const filenameWithExt = urlPath.split("/").pop()!;
      const lastDot = filenameWithExt.lastIndexOf(".");
      const baseName =
        lastDot > 0 ? filenameWithExt.slice(0, lastDot) : filenameWithExt;

      const extension = lastDot > 0 ? filenameWithExt.slice(lastDot + 1) : "";

      const mimeType = blob.type || `video/${extension}`;
      const fileName = extension ? `${baseName}.png` : baseName;
      const file = new File([blob], fileName, { type: mimeType });

      const formData = new FormData();
      formData.append("file", file);
      formData.append("isWatermark", String(isWatermark));
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/image/uploadImage`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (fieldName === "heroBanner") {
        setFieldValue("heroBannerThumb", res.data);
      } else if (fieldName === "showcase") {
        setFieldValue("showcase.thumbUrl", res.data);
      }
      // update another field for thumbnail if needed
      // setFieldValue(imageFieldName, url);
      setImageUploaded(true);
      toast({
        title: "Thumbnail uploaded successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch {
      toast({
        title: "Thumbnail upload failed",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsUploading(false);
    }
  };

  const removeMedia = () => {
    setFieldValue(fieldName, "");
    if (fieldName === "heroBanner") {
      setFieldValue("heroBannerThumb", "");
      setFieldValue("heroBannerAlt", "");
    }
    if (fieldName === "showcase") {
      setFieldValue("showcase.thumbUrl", "");
      setFieldValue("showcase.url", "");
      setFieldValue("showcase.alt", "");
    }
    if (altFieldName) {
      setFieldValue(altFieldName, "");
    }
    setThumbnails([]);
    setSelectedThumb(null);
    setUploadedFile(null);
  };

  const getAcceptAttribute = () => {
    if (allowBothTypes) {
      return "image/*,video/*";
    }
    return isVideo ? "video/*" : "image/*";
  };

  const isCurrentVideo = allowBothTypes ? mediaType === "video" : isVideo;

  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <VStack spacing={4} align="stretch">
        {currentImage && typeof currentImage === "string" ? (
          <Box position="relative" width="100%" maxWidth="300px">
            <Button
              size="sm"
              position="absolute"
              top={2}
              right={2}
              colorScheme="red"
              onClick={removeMedia}
              borderRadius="full"
              zIndex={1}
              p={0}
              minW="30px"
              height="30px"
            >
              <FiX />
            </Button>
            {isCurrentVideo ? (
              <video
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${currentImage}`}
                controls
                style={{ maxHeight: "200px", width: "100%" }}
              />
            ) : (
              <Image
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${currentImage}`}
                alt={currentAlt || label}
                borderRadius="md"
                maxH="200px"
                objectFit="contain"
                width="100%"
                border="1px solid"
                borderColor="gray.200"
              />
            )}
            {(altFieldName || fieldName === "showcase") && (
              <Input
                value={currentAlt || ""}
                placeholder="Alt text"
                size="sm"
                mt={2}
                onChange={(e) =>
                  setFieldValue(
                    fieldName === "showcase" ? "showcase.alt" : altFieldName!,
                    e.target.value,
                  )
                }
              />
            )}
          </Box>
        ) : typeof currentImage === "object" && currentImage.url !== "" ? (
          <Box position="relative" width="100%" maxWidth="300px">
            <Button
              size="sm"
              position="absolute"
              top={2}
              right={2}
              colorScheme="red"
              onClick={removeMedia}
              borderRadius="full"
              zIndex={1}
              p={0}
              minW="30px"
              height="30px"
            >
              <FiX />
            </Button>
            {isCurrentVideo ? (
              <video
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${
                  typeof currentImage === "string"
                    ? currentImage
                    : currentImage.url
                }`}
                controls
                style={{ maxHeight: "200px", width: "100%" }}
              />
            ) : (
              <Image
                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${
                  typeof currentImage === "string"
                    ? currentImage
                    : currentImage.url
                }`}
                alt={
                  typeof currentImage === "string"
                    ? currentAlt || label
                    : currentImage.alt || currentAlt || label
                }
                borderRadius="md"
                maxH="200px"
                objectFit="contain"
                width="100%"
                border="1px solid"
                borderColor="gray.200"
              />
            )}
            {(altFieldName || fieldName === "showcase") && (
              <Input
                value={
                  fieldName === "showcase"
                    ? currentImage?.alt || ""
                    : currentAlt || ""
                }
                placeholder="Alt text"
                size="sm"
                mt={2}
                onChange={(e) =>
                  setFieldValue(
                    fieldName === "showcase" ? "showcase.alt" : altFieldName!,
                    e.target.value,
                  )
                }
              />
            )}
          </Box>
        ) : (
          ""
        )}

        {((typeof currentImage === "string" && currentImage === "") ||
          (typeof currentImage === "object" &&
            (!Object.keys(currentImage).length ||
              currentImage.url === ""))) && (
          <Button
            as="label"
            htmlFor={`media-upload-${fieldName}`}
            cursor="pointer"
            leftIcon={<FiUpload />}
            colorScheme={
              typeof imageError === "string" && imageError ? "red" : "blue"
            }
            variant="outline"
            isLoading={isUploading}
            height="100px"
            border={
              typeof imageError === "string" && imageError
                ? "3px dashed red"
                : "1px dashed "
            }
          >
            <Text
              color={
                typeof imageError === "string" && imageError
                  ? "red.500"
                  : "blue.500"
              }
            >
              {allowBothTypes
                ? "Upload Image or Video"
                : `Upload ${isVideo ? "Video" : "Image"}`}
            </Text>
            <Input
              id={`media-upload-${fieldName}`}
              type="file"
              accept={getAcceptAttribute()}
              onChange={handleUpload}
              display="none"
            />
          </Button>
        )}

        {typeof currentImage === "string" &&
          currentImage &&
          mediaType === "image" && (
            <Button
              as="label"
              htmlFor={`media-upload-${fieldName}`}
              cursor="pointer"
              leftIcon={<FiUpload />}
              colorScheme="blue"
              variant="outline"
              isLoading={isUploading}
              size="sm"
            >
              <Text>
                {allowBothTypes
                  ? "Replace Media"
                  : `Replace ${isVideo ? "Video" : "Image"}`}
              </Text>
              <Input
                id={`media-upload-${fieldName}`}
                type="file"
                accept={getAcceptAttribute()}
                onChange={handleUpload}
                display="none"
              />
            </Button>
          )}

        {(uploadedFile || currentImage) &&
          mediaType === "video" &&
          !isUploading && (
            <Button
              onClick={generateThumbnails}
              variant="outline"
              colorScheme="blue"
              w={"300px"}
              disabled={loadingThumbs || thumbnails.length > 0}
            >
              Get Thumbnails
            </Button>
          )}
        {loadingThumbs && <Spinner mt={4} />}

        {/* Show selected thumbnail with an upload option */}
        {selectedThumb && (
          <Box width="100%" maxWidth="100%" mt={4}>
            <Image
              src={selectedThumb}
              alt={label}
              borderRadius="md"
              maxH="200px"
              objectFit="contain"
              width="200px"
              border="1px solid"
              borderColor="gray.200"
            />

            <Button
              leftIcon={<FiUpload />}
              variant="outline"
              colorScheme="blue"
              w={"300px"}
              mt={4}
              onClick={() => handleUploadThumbnail(selectedThumb)}
              isLoading={isUploading}
            >
              {imageUploaded ? "Uploaded" : "Upload Image"}
            </Button>
          </Box>
        )}

        {/* Horizontal scroll of all thumbnails */}
        {thumbnails.length > 0 && (
          <Flex overflowX="auto" py={1}>
            {thumbnails.map((src, idx) => (
              <Box
                key={idx}
                minW="100px"
                minH="56px"
                mr={2}
                border={selectedThumb === src ? "2px solid" : "1px solid"}
                borderColor={selectedThumb === src ? "blue.500" : "gray.200"}
                cursor="pointer"
                onClick={() => selectThumbnail(src)}
              >
                <Image
                  src={src}
                  alt={`thumb-${idx}`}
                  objectFit="cover"
                  width="100%"
                  height="56px"
                />
              </Box>
            ))}
          </Flex>
        )}
        {/* Hidden video and canvas for capturing thumbnails */}
        <Box display="none">
          <video ref={videoRef} />
          <canvas ref={canvasRef} />
        </Box>
      </VStack>
    </FormControl>
  );
};

interface ImageUploaderProps {
  label: string;
  fieldName: string;
  currentImages: string[] | any | undefined;
  setFieldValue: (field: string, value: any) => void;
  maxImages: number;
  allowVideo?: boolean;
  maxVideos?: number;
  section: keyof typeof IMAGE_LIMITS;
  isWatermark?: boolean;
  currentImageForThumbnail?: string | any;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({
  label,
  fieldName,
  currentImages,
  setFieldValue,
  maxImages,
  allowVideo = false,
  maxVideos = 0,
  section,
  isWatermark = true,
  currentImageForThumbnail,
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadedVideoFile, setUploadedVideoFile] = useState<File | null>(null);
  const [thumbnails, setThumbnails] = useState<string[]>([]);
  const [loadingThumbs, setLoadingThumbs] = useState(false);
  const [selectedThumb, setSelectedThumb] = useState<string | null>(null);
  const [imageUploaded, setImageUploaded] = useState(false);

  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const toast = useToast();
  const isInitial = useRef(true);

  // useEffect(() => {
  //   if (isInitial.current) {
  //     isInitial.current = false;
  //     return; // skip on mount
  //   }
  //   // update selectedThumb only when new videos arrive
  //   if (!selectedThumb && currentImageForThumbnail) {
  //     if (currentImageForThumbnail) {
  //       let thumbUrl: string | null = null;
  //       const base = process.env.REACT_APP_IMAGE_BASE_URL;
  //       if (typeof currentImageForThumbnail === "string") {
  //         thumbUrl = `${base}/${currentImageForThumbnail}`;
  //       } else if (
  //         Array.isArray(currentImageForThumbnail) &&
  //         currentImageForThumbnail.length
  //       ) {
  //         const firstVideo = currentImageForThumbnail[0];
  //         thumbUrl = firstVideo.thumbUrl
  //           ? `${base}/${firstVideo.thumbUrl}`
  //           : null;
  //       } else if (currentImageForThumbnail.thumbUrl) {
  //         thumbUrl = `${base}/${currentImageForThumbnail.thumbUrl}`;
  //       }
  //       console.log("Setting selected thumb:", thumbUrl);

  //       if (thumbUrl) {
  //         setSelectedThumb(thumbUrl);
  //       }
  //     }
  //   }
  // }, [currentImageForThumbnail]);

  //   useEffect(() => {
  //   // do nothing if a thumbnail is already selected
  //   if (selectedThumb) return;

  //   if (currentImageForThumbnail) {
  //     let thumbUrl: string | null = null;
  //     const base = process.env.REACT_APP_IMAGE_BASE_URL;
  //     if (typeof currentImageForThumbnail === "string") {
  //       thumbUrl = `${base}/${currentImageForThumbnail}`;
  //     } else if (
  //       Array.isArray(currentImageForThumbnail) &&
  //       currentImageForThumbnail.length
  //     ) {
  //       const firstVideo = currentImageForThumbnail[0];
  //       thumbUrl = `${base}/${firstVideo.thumbUrl || firstVideo.url}`;
  //     } else if (currentImageForThumbnail.thumbUrl) {
  //       thumbUrl = `${base}/${currentImageForThumbnail.thumbUrl}`;
  //     }
  //     if (thumbUrl) {
  //       setSelectedThumb(thumbUrl);
  //     }
  //   }
  // }, [selectedThumb]);
  // Use a single effect that runs whenever the video changes OR selectedThumb changes
  useEffect(() => {
    // Only set a thumbnail if none is selected and we have a video
    if (!selectedThumb && currentImageForThumbnail) {
      let thumbUrl: string | null = null;
      const base = process.env.REACT_APP_IMAGE_BASE_URL;

      // Handle different types of currentImageForThumbnail
      if (typeof currentImageForThumbnail === "string") {
        // If it's just a URL string
        thumbUrl = `${base}/${currentImageForThumbnail}`;
      } else if (
        Array.isArray(currentImageForThumbnail) &&
        currentImageForThumbnail.length > 0
      ) {
        // If it's an array of video objects, use the first video
        const firstVideo = currentImageForThumbnail[0];
        // Prefer thumbUrl; fall back to the video URL
        if (firstVideo.thumbUrl) {
          thumbUrl = `${base}/${firstVideo.thumbUrl}`;
        }
      } else if (
        typeof currentImageForThumbnail === "object" &&
        currentImageForThumbnail.thumbUrl
      ) {
        // If it's a single object with thumbUrl
        thumbUrl = `${base}/${currentImageForThumbnail.thumbUrl}`;
      }

      if (thumbUrl) {
        console.log("Setting selected thumb:", thumbUrl);
        setSelectedThumb(thumbUrl);
      }
    }
  }, [currentImageForThumbnail, selectedThumb]);

  const videoCount = useMemo(() => {
    if (!currentImages) return 0;

    if (Array.isArray(currentImages)) {
      return currentImages.filter((img) => {
        if (img && typeof img === "object") {
          if (img.mediaType === "video") return true;
          if (img.url && /\.(mp4|webm|ogg|mov)$/i.test(img.url)) return true;
        }
        return false;
      }).length;
    } else if (
      currentImages &&
      typeof currentImages === "object" &&
      (currentImages.mediaType === "video" ||
        (currentImages.url && /\.(mp4|webm|ogg|mov)$/i.test(currentImages.url)))
    ) {
      return 1;
    }

    return 0;
  }, [currentImages]);

  const normalizedImages = useMemo(() => {
    if (!currentImages) {
      return [];
    }

    if (fieldName === "showcase" || fieldName === "showcase.url") {
      if (currentImages && typeof currentImages === "object") {
        if ("url" in currentImages && currentImages.url) {
          return [
            {
              url: currentImages.url,
              alt: currentImages.alt || "",
              _mediaType: currentImages.mediaType || "image",
            },
          ];
        }
      }
      return [];
    }

    if (fieldName === "logo.video") {
      if (currentImages && typeof currentImages === "object") {
        if ("url" in currentImages && currentImages.url) {
          return [
            {
              url: currentImages.url,
              alt: currentImages.alt || "",
              _mediaType: "video",
            },
          ];
        }
      }
      return [];
    }

    if (Array.isArray(currentImages)) {
      return currentImages
        .filter((img) => img && (typeof img === "string" ? img : img.url))
        .map((img) => {
          if (typeof img === "string") {
            const isVideo = /\.(mp4|webm|ogg|mov)$/i.test(img);
            return {
              url: img,
              alt: "",
              thumbUrl: "",
              _mediaType: isVideo ? "video" : "image",
            };
          }

          const isVideo =
            img.mediaType === "video" ||
            (img.url && /\.(mp4|webm|ogg|mov)$/i.test(img.url));

          return {
            url: img.url,
            alt: img.alt || "",
            thumbUrl: img.thumbUrl || "",
            _mediaType: isVideo ? "video" : "image",
          };
        });
    } else if (
      currentImages &&
      typeof currentImages === "object" &&
      "url" in currentImages &&
      currentImages.url
    ) {
      return [
        {
          url: currentImages.url,
          alt: currentImages.alt || "",
          thumbUrl: currentImages.thumbUrl || "",
          _mediaType: currentImages.mediaType || "image",
        },
      ];
    } else if (typeof currentImages === "string" && currentImages) {
      const isVideo = /\.(mp4|webm|ogg|mov)$/i.test(currentImages);
      return [
        {
          url: currentImages,
          alt: "",
          thumbUrl: "",
          _mediaType: isVideo ? "video" : "image",
        },
      ];
    }

    return [];
  }, [currentImages, fieldName]);

  // Only update selectedThumb when there isn't one yet

  const selectThumbnail = (src: string) => {
    setSelectedThumb(src);
    setImageUploaded(false);
  };
  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    if (normalizedImages.length + files.length > maxImages) {
      toast({
        title: `Maximum ${maxImages} media item${
          maxImages > 1 ? "s" : ""
        } allowed for ${section}`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    const newVideoCount = Array.from(files).filter((file) =>
      file.type.startsWith("video/"),
    ).length;

    if (!allowVideo && newVideoCount > 0) {
      toast({
        title: "Videos are not allowed in this section",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (videoCount + newVideoCount > maxVideos) {
      toast({
        title: `Maximum ${maxVideos} video${
          maxVideos > 1 ? "s" : ""
        } allowed for ${section}`,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsUploading(true);

    try {
      const uploadPromises = Array.from(files).map(async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("isWatermark", isWatermark ? "true" : "false");

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/admin/image`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        console.log("response", response.data[0]);

        const isVideo =
          file.type.startsWith("video/") ||
          /\.(mp4|webm|ogg|mov)$/i.test(response.data[0].imageURL);
        if (isVideo) {
          // store the file locally for thumbnail generation
          setUploadedVideoFile(file);
          setThumbnails([]);
          setSelectedThumb(null);
        }
        console.log("mediatype", isVideo ? "video" : "image");
        return {
          url: response.data[0].imageURL,
          alt: file.name.split(".")[0],
          thumbUrl: response.data[0].thumbURL || "",
          _mediaType: isVideo ? "video" : "image",
        };
      });

      const uploadedMedia = await Promise.all(uploadPromises);

      let updatedMedia: any;
      if (maxImages === 1) {
        updatedMedia = uploadedMedia.slice(0, 1);
      } else {
        updatedMedia = [...normalizedImages, ...uploadedMedia];
      }

      if (fieldName === "showcase" || fieldName === "showcase.url") {
        setFieldValue("showcase.url", updatedMedia[0].url);
        setFieldValue("showcase.alt", updatedMedia[0].alt);
        setFieldValue("showcase.thumbUrl", updatedMedia[0].thumbUrl);
      } else if (fieldName === "logo.video") {
        setFieldValue("logo.video", {
          url: updatedMedia[0].url,
          alt: updatedMedia[0].alt,
          thumbUrl: updatedMedia[0].thumbUrl,
        });
      } else if (fieldName === "userFlow.image") {
        const cleanedMedia =
          maxImages === 1
            ? {
                thumbUrl: updatedMedia[0].thumbUrl,
                url: updatedMedia[0].url,
                alt: updatedMedia[0].alt,
                _mediaType: updatedMedia[0]._mediaType,
              }
            : updatedMedia.map((item: any) => ({
                thumbUrl: item.thumbUrl,
                url: item.url,
                alt: item.alt,
                _mediaType: item._mediaType,
              }));

        setFieldValue("userFlow.image", cleanedMedia);
      } else if (fieldName === "revenue.image") {
        const cleanedMedia =
          maxImages === 1
            ? {
                thumbUrl: updatedMedia[0].thumbUrl,
                url: updatedMedia[0].url,
                alt: updatedMedia[0].alt,
                _mediaType: updatedMedia[0]._mediaType,
              }
            : updatedMedia.map((item: any) => ({
                thumbUrl: item.thumbUrl,
                url: item.url,
                alt: item.alt,
                _mediaType: item._mediaType,
              }));

        setFieldValue("revenue.image", cleanedMedia);
      } else {
        const cleanedMedia =
          maxImages === 1
            ? {
                url: updatedMedia[0].url,
                alt: updatedMedia[0].alt,
                _mediaType: updatedMedia[0]._mediaType,
                thumbUrl: updatedMedia[0].thumbUrl
                  ? updatedMedia[0].thumbUrl
                  : "",
              }
            : updatedMedia.map((item: any) => ({
                url: item.url,
                alt: item.alt,
                _mediaType: item._mediaType,
                thumbUrl: item.thumbUrl ? item.thumbUrl : "",
              }));

        setFieldValue(fieldName, cleanedMedia);
      }

      toast({
        title: `Media item${files.length > 1 ? "s" : ""} uploaded successfully`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error uploading media:", error);
      toast({
        title: "Failed to upload media",
        description: error instanceof Error ? error.message : "Unknown error",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsUploading(false);
      e.target.value = "";
    }
  };

  const generateThumbnails = async () => {
    const videoEl = videoRef.current;
    const canvas = canvasRef.current;
    if (!videoEl || !canvas) return;

    videoEl.crossOrigin = "anonymous"; // avoid tainting the canvas

    // Determine which video to use: new upload or existing
    let src: string | null = null;
    if (uploadedVideoFile) {
      src = URL.createObjectURL(uploadedVideoFile);
    } else {
      const videoItem = normalizedImages.find(
        (img) => img._mediaType === "video",
      );
      if (videoItem) {
        src = `${process.env.REACT_APP_IMAGE_BASE_URL}/${videoItem.url}`;
      }
    }
    if (!src) return;

    setLoadingThumbs(true);
    setThumbnails([]);
    setSelectedThumb(null);

    videoEl.src = src;
    videoEl.load();
    videoEl.onloadedmetadata = () => {
      const duration = videoEl.duration;
      const step = 0.5;
      let current = 0;
      const thumbs: string[] = [];
      const ctx = canvas.getContext("2d");

      const capture = () => {
        videoEl.currentTime = current;
      };
      videoEl.onseeked = () => {
        canvas.width = videoEl.videoWidth;
        canvas.height = videoEl.videoHeight;
        ctx?.drawImage(videoEl, 0, 0);
        thumbs.push(canvas.toDataURL());
        current += step;
        if (current <= duration) {
          capture();
        } else {
          setThumbnails(thumbs);
          setSelectedThumb(thumbs[0] || null);
          setLoadingThumbs(false);
          if (uploadedVideoFile) {
            URL.revokeObjectURL(src!);
          }
        }
      };
      capture();
    };
  };

  const handleUploadThumbnail = async (src: string) => {
    if (!src) return;
    setIsUploading(true);
    try {
      const blob = await fetch(src).then((res) => res.blob());
      const videoMedia = normalizedImages.find(
        (media) =>
          media._mediaType === "video" ||
          fieldName === "logo.video" ||
          /\.(mp4|webm|ogg|mov)$/i.test(media.url || ""),
      );

      if (!videoMedia?.url) {
        throw new Error("No video URL found in normalizedImages");
      }
      const urlPath = `${process.env.REACT_APP_IMAGE_BASE_URL}/${videoMedia.url}`;

      const filenameWithExt = urlPath.split("/").pop()!;
      const lastDot = filenameWithExt.lastIndexOf(".");
      const baseName =
        lastDot > 0 ? filenameWithExt.slice(0, lastDot) : filenameWithExt;
      const extension = lastDot > 0 ? filenameWithExt.slice(lastDot + 1) : "";

      const mimeType = blob.type || `video/${extension}`;
      const fileName = extension ? `${baseName}.png` : baseName;
      const file = new File([blob], fileName, { type: mimeType });

      const formData = new FormData();
      formData.append("file", file);
      formData.append("isWatermark", String(isWatermark));
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/image/uploadImage`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      // update thumbnail field; if only one video, update the first media item
      if (maxImages === 1) {
        setFieldValue(fieldName, {
          ...normalizedImages[0],
          thumbUrl: res.data,
        });
      } else {
        const updated: any = [...normalizedImages];
        const videoIdx = updated.findIndex(
          (item: any) => item._mediaType === "video",
        );
        if (videoIdx >= 0) {
          updated[videoIdx] = { ...updated[videoIdx], thumbUrl: res.data };
          setFieldValue(fieldName, updated);
        }
      }
      setImageUploaded(true);
      toast({
        title: "Thumbnail uploaded successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Thumbnail upload failed",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsUploading(false);
    }
  };

  // const removeImage = (index: number) => {
  //   const mediaToRemove = normalizedImages[index];

  //   if (fieldName === "showcase" || fieldName === "showcase.url") {
  //     setFieldValue("showcase.url", "");
  //     setFieldValue("showcase.alt", "");
  //     return;
  //   } else if (fieldName === "logo.video") {
  //     setFieldValue("logo.video", { url: "", alt: "" });
  //     setThumbnails([]);
  //     setSelectedThumb(null);
  //     setUploadedVideoFile(null);
  //     // setUploadedFile(null);
  //     return;
  //   } else if (fieldName === "wireFrame.images") {
  //     setFieldValue("wireFrame.images", []);
  //     setThumbnails([]);
  //     setSelectedThumb(null);
  //     setUploadedVideoFile(null);
  //   } else if (fieldName === "uiDesign.screens") {
  //     setFieldValue("uiDesign.screens", { url: "", alt: "" });
  //     setThumbnails([]);
  //     setSelectedThumb(null);
  //     setUploadedVideoFile(null);
  //   }
  //   if (
  //     mediaToRemove._mediaType === "video" ||
  //     mediaToRemove.url?.includes(".mp4")
  //   ) {
  //     const updatedImages = normalizedImages.filter((_, idx) => idx !== index);
  //     setFieldValue(fieldName, updatedImages); // Remove video
  //     setThumbnails([]); // Clear thumbnails because the video is removed
  //     setSelectedThumb(null); // Clear selected thumbnail
  //     setUploadedVideoFile(null); // Clear the uploaded video file
  //   } else {
  //     // If it's an image, only remove the image but keep the thumbnail
  //     const updatedImages = normalizedImages.filter((_, idx) => idx !== index);
  //     console.log("Updated images after removal:--", normalizedImages);
  //     setFieldValue(fieldName, updatedImages); // Remove image
  //     // Do not clear the thumbnails list for images
  //   }

  //   if (maxImages === 1) {
  //     setFieldValue(fieldName, null);
  //   } else {
  //     const updatedImages = [...normalizedImages];
  //     updatedImages.splice(index, 1);
  //     console.log("Updated images after removal:", updatedImages);

  //     setFieldValue(fieldName, updatedImages);
  //     setThumbnails([]);
  //     setSelectedThumb(null);
  //     setUploadedVideoFile(null);
  //   }
  // };

  // If it's a video, remove both the video and its thumbnail

  const removeImage = (index: number) => {
    const mediaToRemove = normalizedImages[index];

    // Create a new array without the removed item (don’t mutate state directly):contentReference[oaicite:4]{index=4}
    let updatedImages: any = normalizedImages.filter((_, i) => i !== index);

    if (Array.isArray(updatedImages) && !updatedImages.length) {
      updatedImages = { url: "", alt: "", thumbUrl: "", _mediaType: "" };
    }
    console.log(
      "mediaToRemove--",
      updatedImages,
      "hjjh",
      normalizedImages,
      index,
      Array.isArray(updatedImages),
    );
    // Remove video and its thumbnail
    if (
      mediaToRemove._mediaType === "video" ||
      /\.(mp4|webm|ogg|mov)$/i.test(mediaToRemove.url)
    ) {
      setFieldValue(fieldName, updatedImages);
      setThumbnails([]); // clear thumbnails only for video removal
      setSelectedThumb(null);
      setUploadedVideoFile(null);
    } else {
      // Remove image but preserve existing thumbnails
      setFieldValue(fieldName, updatedImages);
      // don’t call setThumbnails or setSelectedThumb here
    }
  };

  const updateAltText = (index: number, newAlt: string) => {
    if (fieldName === "showcase" || fieldName === "showcase.url") {
      setFieldValue("showcase.alt", newAlt);
      return;
    } else if (fieldName === "logo.video") {
      setFieldValue("logo.video", {
        ...normalizedImages[0],
        alt: newAlt,
      });
      return;
    }

    if (maxImages === 1) {
      setFieldValue(fieldName, {
        ...normalizedImages[0],
        url: normalizedImages[0].url,
        alt: newAlt,
      });
    } else {
      const updatedImages = normalizedImages.map((item, idx) =>
        idx === index ? { ...item, alt: newAlt } : item,
      );
      setFieldValue(fieldName, updatedImages);
    }
  };

  const imagesRemaining = maxImages - normalizedImages.length;
  const videosRemaining = allowVideo ? maxVideos - videoCount : 0;
  const hasVideo =
    uploadedVideoFile ||
    normalizedImages.some((img) => img._mediaType === "video");

  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>
      <VStack spacing={4} align="stretch">
        {normalizedImages.length > 0 && (
          <Flex flexWrap="wrap" gap={4}>
            {normalizedImages.map((media, index) => (
              <Box key={index} position="relative" width="48%" maxWidth="300px">
                <Button
                  size="sm"
                  position="absolute"
                  top={2}
                  right={2}
                  colorScheme="red"
                  onClick={() => removeImage(index)}
                  borderRadius="full"
                  zIndex={1}
                  p={0}
                  minW="30px"
                  height="30px"
                >
                  <FiX />
                </Button>

                {media._mediaType === "video" ||
                fieldName === "logo.video" ||
                (media.url && /\.(mp4|webm|ogg|mov)$/i.test(media.url)) ? (
                  <Box
                    borderRadius="md"
                    border="1px solid"
                    borderColor="gray.200"
                    position="relative"
                  >
                    <video
                      key={media.url}
                      controls
                      preload="metadata"
                      playsInline
                      muted
                      style={{
                        width: "100%",
                        maxHeight: "200px",
                        objectFit: "contain",
                      }}
                    >
                      <source
                        src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${media.url}`}
                        type="video/mp4"
                      />
                      <source
                        src={`${
                          process.env.REACT_APP_IMAGE_BASE_URL
                        }/${media.url.replace(".mp4", ".webm")}`}
                        type="video/webm"
                      />
                      Your browser does not support the video tag.
                    </video>
                    <Badge
                      colorScheme="purple"
                      m={2}
                      position="absolute"
                      top={0}
                      left={0}
                    >
                      Video
                    </Badge>
                  </Box>
                ) : (
                  <Image
                    src={
                      media
                        ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${media.url}`
                        : "/placeholder.svg"
                    }
                    alt={media.alt || label}
                    borderRadius="md"
                    maxH="200px"
                    objectFit="contain"
                    width="100%"
                    border="1px solid"
                    borderColor="gray.200"
                  />
                )}

                <Input
                  value={media.alt || ""}
                  placeholder="Alt text"
                  size="sm"
                  mt={2}
                  onChange={(e: any) => updateAltText(index, e.target.value)}
                />
              </Box>
            ))}
          </Flex>
        )}

        {(uploadedVideoFile || hasVideo) && !isUploading && (
          <Button
            onClick={generateThumbnails}
            variant="outline"
            colorScheme="blue"
            w={"300px"}
            disabled={loadingThumbs || thumbnails.length > 0}
            mt={2}
          >
            Get Thumbnails
          </Button>
        )}
        {loadingThumbs && <Spinner mt={4} />}
        {selectedThumb && (
          <Box width="100%" maxWidth="100%" mt={4}>
            <Image
              src={selectedThumb}
              alt={label}
              borderRadius="md"
              maxH="200px"
              objectFit="contain"
              width="200px"
              // w={"300px"}
              border="1px solid"
              borderColor="gray.200"
            />
            <Button
              leftIcon={<FiUpload />}
              variant="outline"
              w={"300px"}
              mt={4}
              colorScheme="blue"
              onClick={() => handleUploadThumbnail(selectedThumb)}
              isLoading={isUploading}
            >
              {imageUploaded ? "Uploaded" : "Upload Image"}
            </Button>
          </Box>
        )}
        {thumbnails.length > 0 && (
          <Flex overflowX="auto" py={1} mt={2}>
            {thumbnails.map((src, idx) => (
              <Box
                key={idx}
                minW="100px"
                minH="56px"
                mr={2}
                border={selectedThumb === src ? "2px solid" : "1px solid"}
                borderColor={selectedThumb === src ? "blue.500" : "gray.200"}
                cursor="pointer"
                onClick={() => selectThumbnail(src)}
              >
                <Image
                  src={src}
                  alt={`thumb-${idx}`}
                  objectFit="cover"
                  width="100%"
                  height="56px"
                />
              </Box>
            ))}
          </Flex>
        )}
        {normalizedImages.length < maxImages && (
          <>
            <Button
              as="label"
              htmlFor={`media-upload-${fieldName}`}
              cursor="pointer"
              leftIcon={<FiUpload />}
              colorScheme="blue"
              variant="outline"
              isLoading={isUploading}
              height="100px"
              borderStyle="dashed"
            >
              <Text>
                {normalizedImages.length === 0 ? "Upload" : "Add"} {label}
                {maxImages > 1 && ` (${normalizedImages.length}/${maxImages})`}
                {allowVideo &&
                  (fieldName === "logo.video"
                    ? " (Video Only)"
                    : ` - Images ${
                        maxVideos > 0 ? `& up to ${maxVideos} video` : ""
                      }`)}
              </Text>
              <Input
                id={`media-upload-${fieldName}`}
                type="file"
                accept={
                  fieldName === "logo.video"
                    ? "video/*"
                    : allowVideo
                      ? "image/*,video/*"
                      : "image/*"
                }
                onChange={handleUpload}
                display="none"
                multiple={maxImages > 1}
              />
            </Button>
            <Text fontSize="sm" color="gray.600" textAlign="center">
              {imagesRemaining > 0
                ? `${imagesRemaining} image${
                    imagesRemaining !== 1 ? "s" : ""
                  } remaining`
                : "Maximum images reached"}
              {allowVideo &&
                maxVideos > 0 &&
                videosRemaining > 0 &&
                ` • ${videosRemaining} video${
                  videosRemaining !== 1 ? "s" : ""
                } remaining`}
            </Text>
          </>
        )}
        {/* Hidden elements for capturing thumbnails */}
        <Box display="none">
          <video ref={videoRef} />
          <canvas ref={canvasRef} />
        </Box>

        {normalizedImages.length >= maxImages && (
          <Text fontSize="sm" color="gray.600" textAlign="center">
            Maximum limit reached ({maxImages}{" "}
            {maxImages === 1 ? "file" : "files"})
          </Text>
        )}
      </VStack>
    </FormControl>
  );
};

const CasestudyEditDrawer: React.FC<CasestudyFormDrawerProps> = ({
  isOpen,
  onClose,
  bannerData,
  casestudyData,
  refreshData,
}) => {
  const { masterCasestudy, busy } = useCasestudyMaster();
  const dispatch = useDispatch();
  const toast = useToast();
  const [bannerCategoryNames, setBannerCategoryNames] = useState<any[]>([]);
  const [bannerCategoryFilter, setBannerCategoryFilter] = useState<string>(
    bannerData?.type || "",
  );
  const [bannerSubCategoryNames, setBannerSubCategoryNames] = useState<any[]>(
    [],
  );
  const [bannerIndustryNames, setBannerIndustryNames] = useState<any[]>([]);
  const [bannerSubCategoryFilter, setBannerSubCategoryFilter] =
    useState<string>(bannerData?.subCategory || "");
  const [bannerIndustryFilter, setBannerIndustryFilter] = useState<string>(
    bannerData?.subCategory || "",
  );
  const [mainCategories, setMainCategories] = useState<any>([]);
  const [subCategories, setSubCategories] = useState<any>([]);
  const [serviceTypes, setServiceTypes] = useState<any>([]);
  const [selectedMainCategory, setSelectedMainCategory] = useState<string>("");
  const [selectedSubCategory, setSelectedSubCategory] = useState<string>("");
  const [selectedServiceType, setSelectedServiceType] = useState<string>("");
  const [newBannerCategory, setNewBannerCategory] = useState<string>("");
  const [newBannerSubCategory, setNewBannerSubCategory] = useState<string>("");
  const [newBannerIndustry, setNewBannerIndustry] = useState<string>("");
  const [industryData, setIndustryData] = useState<any[]>([]);
  const [selectedIndustryData, setSelectedIndustryData] = useState<any>(null);
  const [availableHashtags, setAvailableHashtags] = useState<string[]>([]);
  const [selectedHashtags, setSelectedHashtags] = useState<string[]>([]);
  const [newHashtag, setNewHashtag] = useState<string>("");
  const getIndustryNameById = (industryId: any) => {
    const industry: any = industryData.find(
      (item: any) => item._id === industryId,
    );
    return industry ? industry.name : "";
  };
  const ensureArray = (value: any) => {
    if (Array.isArray(value)) return value;
    return value ? [value] : [];
  };

  const handleIndustryChange = (industryName: any, setFieldValue: any) => {
    setBannerIndustryFilter(industryName);

    const selectedIndustry: any = industryData.find(
      (item: any) => item.name === industryName,
    );
    setSelectedIndustryData(selectedIndustry);

    if (selectedIndustry) {
      setFieldValue("banner_workIndustry", selectedIndustry._id);
      setAvailableHashtags(selectedIndustry.hashtags || []);
    } else {
      setFieldValue("banner_workIndustry", "");
      setAvailableHashtags([]);
    }

    setSelectedHashtags([]);
    setFieldValue("banner_hashtags", []);
  };

  const handleHashtagSelect = (hashtag: any, setFieldValue: any) => {
    if (!selectedHashtags.includes(hashtag)) {
      const updatedHashtags = [...selectedHashtags, hashtag];
      setSelectedHashtags(updatedHashtags);
      setFieldValue("banner_hashtags", updatedHashtags);
    }
  };

  const removeSelectedHashtag = (hashtagToRemove: any, setFieldValue: any) => {
    const updatedHashtags = selectedHashtags.filter(
      (tag) => tag !== hashtagToRemove,
    );
    setSelectedHashtags(updatedHashtags);
    setFieldValue("banner_hashtags", updatedHashtags);
  };

  const handleAddNewIndustry = async (setFieldValue: any) => {
    if (!newBannerIndustry.trim()) return;

    try {
      let tkn = localStorage.getItem("token");
      const payload = {
        name: newBannerIndustry,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/admin/workIndustry`,
        payload,
        {
          headers: {
            Authorization: `${tkn}`,
          },
        },
      );

      console.log("API Response:", response.data);

      const newIndustry = response.data.workIndustry;

      if (!newIndustry || !newIndustry._id) {
        throw new Error("Invalid response structure or missing ID");
      }

      setIndustryData((prev) => [...prev, newIndustry]);
      setBannerIndustryNames((prev) => [...prev, newBannerIndustry]);

      setBannerIndustryFilter(newBannerIndustry);
      setSelectedIndustryData(newIndustry);

      setFieldValue("banner_workIndustry", newIndustry._id);
      setAvailableHashtags(newIndustry.hashtags || []);

      setSelectedHashtags([]);
      setFieldValue("banner_hashtags", []);

      setNewBannerIndustry("");

      toast({
        title: "Success",
        description: "Industry added successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error adding industry:", error);
      toast({
        title: "Error",
        description: "Failed to add industry",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleAddNewHashtag = async () => {
    if (!newHashtag.trim() || !selectedIndustryData) return;

    const formattedHashtag = newHashtag.startsWith("#")
      ? newHashtag
      : `${newHashtag}`;

    try {
      let tkn = localStorage.getItem("token");
      const payload = {
        id: selectedIndustryData._id,
        name: selectedIndustryData.name,
        hashtags: [...(selectedIndustryData.hashtags || []), formattedHashtag],
      };

      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/admin/workIndustry/`,
        payload,
        {
          headers: {
            Authorization: `${tkn}`,
          },
        },
      );

      const updatedHashtags = [...availableHashtags, formattedHashtag];
      setAvailableHashtags(updatedHashtags);

      const updatedIndustryData: any = industryData.map((item: any) =>
        item._id === selectedIndustryData._id
          ? { ...item, hashtags: updatedHashtags }
          : item,
      );
      setIndustryData(updatedIndustryData);
      setSelectedIndustryData({
        ...selectedIndustryData,
        hashtags: updatedHashtags,
      });

      setNewHashtag("");

      toast({
        title: "Success",
        description: "Hashtag added successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error adding hashtag:", error);
      toast({
        title: "Error",
        description: "Failed to add hashtag",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const initialValues = useMemo(() => {
    if (bannerData || casestudyData) {
      return {
        banner_imageURL: bannerData?.imageURL || "",
        bannerImageAlt: bannerData?.bannerImageAlt || "",
        banner_videoURL: bannerData?.videoURL || "",
        banner_thumbUrl: bannerData?.thumbUrl || "",
        banner_title: bannerData?.title || "",
        banner_description: bannerData?.description || "",
        banner_type: bannerData.type || "Graphics Design",
        banner_subCategory: bannerData?.subCategory || "",
        banner_workIndustry: bannerData?.workIndustry?.[0] || "",
        banner_metaDescription: bannerData?.metaDescription || "",
        banner_metaTitle: bannerData?.metaTitle || "",
        // banner_workIndustry: bannerData?.industry || "",
        banner_hashtags: bannerData?.hashtags || [],
        banner_titleUrl: bannerData?.titleUrl || "",
        main_category: bannerData?.mainCategoryId || "",
        sub_category: bannerData?.subCategoryId || "",
        service_type: bannerData?.serviceId || "",
        title: casestudyData?.title || "",
        subtitle: casestudyData?.subtitle || "",
        description: casestudyData?.description || "",
        projectFocus: {
          categories: casestudyData?.projectFocus?.categories || [],
        },
        heroBanner: casestudyData?.heroBanner || "",
        heroBannerAlt: casestudyData?.heroBannerAlt || "",
        heroBannerThumb: casestudyData?.heroBannerThumb || "",
        projectDetails: {
          industry: casestudyData?.projectDetails?.industry || "",
          tools: (casestudyData?.projectDetails?.tools || []).map(
            (tool: string | { url?: string; alt?: string }) =>
              typeof tool === "string"
                ? { url: tool, alt: "" }
                : { url: tool.url || "", alt: tool.alt || "" },
          ),
          projectType: casestudyData?.projectDetails?.projectType || "",
          projectYear: casestudyData?.projectDetails?.projectYear || "",
          keyMarket: casestudyData?.projectDetails?.keyMarket || "",
          playstoreUrl: casestudyData?.projectDetails?.playstoreUrl || "",
        },
        overview: {
          sectionNumber: casestudyData?.overview?.sectionNumber || "",
          title: casestudyData?.overview?.title || "",
          description: casestudyData?.overview?.description || "",
          images: casestudyData?.overview?.images || [{ url: "", alt: "" }],
        },
        sidebar: {
          industry: casestudyData?.sidebar?.industry || "",
          whatWeDid: casestudyData?.sidebar?.whatWeDid || [],
          platform: {
            name: casestudyData?.sidebar?.platform?.name || "",
            type: ensureArray(casestudyData?.sidebar?.platform?.type),
          },
        },
        problem: {
          sectionNumber: casestudyData?.problem?.sectionNumber || "",
          title: casestudyData?.problem?.title || "",
          description: casestudyData?.problem?.description || "",
        },
        solution: {
          sectionNumber: casestudyData?.solution?.sectionNumber || "",
          title: casestudyData?.solution?.title || "",
          description: casestudyData?.solution?.description || "",
        },
        showcase: {
          url: casestudyData?.showcase?.url || "",
          alt: casestudyData?.showcase?.alt || "",
          thumbUrl: casestudyData?.showcase?.thumbUrl || "",
        },
        designVision: {
          sectionNumber: casestudyData?.designVision?.sectionNumber || "",
          title: casestudyData?.designVision?.title || "",
          subtitle: casestudyData?.designVision?.subtitle || "",
          description: casestudyData?.designVision?.description || "",
          images: casestudyData?.designVision?.images || [
            { url: "", alt: "", thumbUrl: "" },
          ],
        },
        userFlow: {
          sectionNumber: casestudyData?.userFlow?.sectionNumber || "",
          title: casestudyData?.userFlow?.title || "",
          description: casestudyData?.userFlow?.description || "",
          image: {
            url: casestudyData?.userFlow?.image?.url || "",
            alt: casestudyData?.userFlow?.image?.alt || "",
          },
        },
        revenue: {
          sectionNumber: casestudyData?.revenue?.sectionNumber || "",
          title: casestudyData?.revenue?.title || "",
          description: casestudyData?.revenue?.description || "",
          image: {
            url: casestudyData?.revenue?.image?.url || "",
            alt: casestudyData?.revenue?.image?.alt || "",
          },
        },
        logo: {
          sectionNumber: casestudyData?.logo?.sectionNumber || "",
          title: casestudyData?.logo?.title || "",
          description: casestudyData?.logo?.description || "",
          video: {
            url: casestudyData?.logo?.video?.url || "",
            alt: casestudyData?.logo?.video?.alt || "",
            thumbUrl: casestudyData?.logo?.video?.thumbUrl || "",
          },
          images: casestudyData?.logo?.images || [{ url: "", alt: "" }],
          logo1ImageBanner: casestudyData?.logo?.logo1ImageBanner || {
            url: "",
            alt: "",
          },
        },

        typography: {
          sectionNumber: casestudyData?.typography?.sectionNumber || "",
          title: casestudyData?.typography?.title || "",
          fontFamily: ensureArray(casestudyData?.typography?.fontFamily),

          description: casestudyData?.typography?.description || "",
          images: casestudyData?.typography?.images || [{ url: "", alt: "" }],
        },
        colorPalette: {
          sectionNumber: casestudyData?.colorPalette?.sectionNumber || "",
          title: casestudyData?.colorPalette?.title || "",
          description: casestudyData?.colorPalette?.description || "",
          image: {
            url: casestudyData?.colorPalette?.image?.url || "",
            alt: casestudyData?.colorPalette?.image?.alt || "",
          },
        },
        wireFrame: {
          sectionNumber: casestudyData?.wireFrame?.sectionNumber || "",
          title: casestudyData?.wireFrame?.title || "",
          description: casestudyData?.wireFrame?.description || "",
          images: {
            url: casestudyData?.wireFrame?.images?.url || "",
            alt: casestudyData?.wireFrame?.images?.alt || "",
            thumbUrl: casestudyData?.wireFrame?.images?.thumbUrl || "",
          },
        },
        uiDesign: {
          sectionNumber: casestudyData?.uiDesign?.sectionNumber || "",
          title: casestudyData?.uiDesign?.title || "",
          description: casestudyData?.uiDesign?.description || "",
          screens: {
            url: casestudyData?.uiDesign?.screens?.url || "",
            alt: casestudyData?.uiDesign?.screens?.alt || "",
            thumbUrl: casestudyData?.uiDesign?.screens?.thumbUrl || "",
          },
        },
        metadata: {
          platform: casestudyData?.metadata?.platform || "",
          image: {
            url: casestudyData?.metadata?.image?.url || "",
            alt: casestudyData?.metadata?.image?.alt || "",
          },
          projectUrl: casestudyData?.metadata?.projectUrl || "",
        },
        slider: {
          sectionNumber: casestudyData?.slider?.sectionNumber || "",
          title: casestudyData?.slider?.title || "",
          description: casestudyData?.slider?.description || "",
          screens: casestudyData?.slider?.screens || [{ url: "", alt: "" }],
        },
      };
    }
    return {
      banner_imageURL: "",
      bannerImageAlt: "",
      banner_videoURL: "",
      banner_thumbUrl: "",
      banner_title: "",
      banner_description: "",
      banner_type: "Graphics Design",
      banner_subCategory: "AI",
      banner_workIndustry: "",
      banner_hashtags: [],
      banner_titleUrl: "",
      banner_metaDescription: "",
      banner_metaTitle: "",
      main_category: "",
      sub_category: "",
      service_type: "",
      title: "",
      subtitle: "",
      description: "",
      projectFocus: {
        categories: [],
      },
      heroBanner: "",
      heroBannerAlt: "",
      heroBannerThumb: "",
      projectDetails: {
        industry: "",
        tools: [],
        projectType: "",
        projectYear: "",
        keyMarket: "",
        playstoreUrl: "",
      },
      overview: {
        sectionNumber: "",
        title: "",
        description: "",
        images: [{ url: "", alt: "" }],
      },
      sidebar: {
        industry: "",
        whatWeDid: [],
        platform: {
          name: "",
          type: [],
        },
      },
      problem: {
        sectionNumber: "",
        title: "",
        description: "",
      },
      solution: {
        sectionNumber: "",
        title: "",
        description: "",
      },
      showcase: {
        url: "",
        alt: "",
        thumbUrl: "",
      },
      designVision: {
        sectionNumber: "",
        title: "",
        subtitle: "",
        description: "",
        images: [{ url: "", alt: "", thumbUrl: "" }],
      },
      userFlow: {
        sectionNumber: "",
        title: "",
        description: "",
        image: {
          url: "",
          alt: "",
        },
      },
      revenue: {
        sectionNumber: "",
        title: "",
        description: "",
        image: {
          url: "",
          alt: "",
        },
      },
      logo: {
        sectionNumber: "",
        title: "",
        description: "",
        video: {
          url: "",
          alt: "",
          thumbUrl: "",
        },
        images: [{ url: "", alt: "" }],
        logo1ImageBanner: { url: "", alt: "" },
      },
      typography: {
        sectionNumber: "",
        title: "",
        fontFamily: [],
        description: "",
        images: [{ url: "", alt: "" }],
      },
      colorPalette: {
        sectionNumber: "",
        title: "",
        description: "",
        image: {
          url: "",
          alt: "",
        },
      },
      wireFrame: {
        sectionNumber: "",
        title: "",
        description: "",
        images: {
          url: "",
          alt: "",
          thumbUrl: "",
        },
      },
      uiDesign: {
        sectionNumber: "",
        title: "",
        description: "",
        screens: {
          url: "",
          alt: "",
          thumbUrl: "",
        },
      },
      metadata: {
        platform: "",
        image: {
          url: "",
          alt: "",
        },
        projectUrl: "",
      },
      slider: {
        sectionNumber: "",
        title: "",
        description: "",
        screens: [{ url: "", alt: "" }],
      },
    };
  }, [bannerData, casestudyData]);

  useEffect(() => {
    const getBannerCategoryNames = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/category/names`,
        );
        setBannerCategoryNames(response.data);
        if (bannerData?.type && !response.data.includes(bannerData.type)) {
          setBannerCategoryNames((prev) => [...prev, bannerData.type]);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getBannerCategoryNames();
  }, []);

  useEffect(() => {
    const getBannerSubCategoriesNames = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/category/subcategory/names`,
        );
        setBannerSubCategoryNames(response.data);
        if (
          bannerData?.subCategory &&
          !response.data.includes(bannerData.subCategory)
        ) {
          setBannerSubCategoryNames((prev) => [
            ...prev,
            bannerData.subCategory,
          ]);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getBannerSubCategoriesNames();
  }, []);

  // useEffect(() => {
  //   const getBannerIndustryNames = async () => {
  //     let tkn = localStorage.getItem("token");
  //     if (!tkn) {
  //       return;
  //     }
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BASE_URL}/admin/workIndustry`,
  //         {
  //           headers: {
  //             Authorization: `${tkn}`,
  //           },
  //         }
  //       );

  //       if (response.data.success) {
  //         setIndustryData(response.data.data);
  //         setBannerIndustryNames(
  //           response.data.data.map((item: any) => item.name)
  //         );

  //         if (bannerData?.industry) {
  //           let existingIndustry;
  //           if (bannerData.industry.length === 24) {
  //             existingIndustry = response.data.data.find(
  //               (item: any) => item._id === bannerData.industry
  //             );
  //           } else {
  //             existingIndustry = response.data.data.find(
  //               (item: any) => item.name === bannerData.industry
  //             );
  //           }

  //           if (existingIndustry) {
  //             setSelectedIndustryData(existingIndustry);
  //             setBannerIndustryFilter(existingIndustry.name);
  //             setAvailableHashtags(existingIndustry.hashtags || []);

  //             if (bannerData.hashtags) {
  //               setSelectedHashtags(bannerData.hashtags);
  //             }
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   getBannerIndustryNames();
  // }, [bannerData]);

  console.log(bannerIndustryNames, "bbbbbbbbbbbbb");
  useEffect(() => {
    const getBannerIndustryNames = async () => {
      let tkn = localStorage.getItem("token");
      if (!tkn) {
        return;
      }
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/workIndustry`,
          {
            headers: {
              Authorization: `${tkn}`,
            },
          },
        );

        if (response.data.success) {
          setIndustryData(response.data.data);
          setBannerIndustryNames(
            // response.data.data.map((item: any) => item.name)
            response.data.data,
          );

          if (bannerData?.workIndustry && bannerData.workIndustry.length > 0) {
            // Get the first industry ID from the workIndustry array
            const industryId = bannerData.workIndustry[0];
            console.log("industryId", industryId);

            // Find the industry by ID
            const existingIndustry = response.data.data.find(
              (item: any) => item._id === industryId,
            );
            console.log("existingIndustry", existingIndustry);

            if (existingIndustry) {
              setSelectedIndustryData(existingIndustry);
              setBannerIndustryFilter(existingIndustry.name);
              setAvailableHashtags(existingIndustry.hashtags || []);

              // Set selected hashtags if they exist in bannerData
              if (bannerData.hashtags && bannerData.hashtags.length > 0) {
                setSelectedHashtags(bannerData.hashtags);
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    getBannerIndustryNames();
  }, [bannerData]);

  useEffect(() => {
    const getMainCategories = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/mainCategory`,
        );
        setMainCategories(response.data);
        console.log("mainCategories", response.data);
      } catch (error) {
        console.log(error);
      }
    };

    getMainCategories();
  }, []);

  useEffect(() => {
    const getSubCategories = async () => {
      if (!selectedMainCategory) {
        setSubCategories([]);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/subCategory?mainCategoryId=${selectedMainCategory}`,
        );
        setSubCategories(response.data);
        setSelectedSubCategory("");
        setSelectedServiceType("");
        setServiceTypes([]);
      } catch (error) {
        console.log(error);
        toast({
          title: "Error",
          description: "Failed to fetch subcategories",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    getSubCategories();
  }, [selectedMainCategory]);

  useEffect(() => {
    const getServiceTypes = async () => {
      if (!selectedSubCategory) {
        setServiceTypes([]);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/service?subCategoryId=${selectedSubCategory}`,
        );
        setServiceTypes(response.data);

        setSelectedServiceType("");
      } catch (error) {
        console.log(error);
        toast({
          title: "Error",
          description: "Failed to fetch service types",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };

    getServiceTypes();
  }, [selectedSubCategory]);

  const handleAddBannerCategory = () => {
    if (
      newBannerCategory.trim() &&
      !bannerCategoryNames.includes(newBannerCategory)
    ) {
      setBannerCategoryNames((prev) => [...prev, newBannerCategory]);
      setBannerCategoryFilter(newBannerCategory);
      setNewBannerCategory("");
    }
  };

  const handleAddBannerSubCategory = () => {
    if (
      newBannerSubCategory.trim() &&
      !bannerSubCategoryNames.includes(newBannerSubCategory)
    ) {
      setBannerSubCategoryNames((prev) => [...prev, newBannerSubCategory]);
      setBannerSubCategoryFilter(newBannerSubCategory);
      setNewBannerSubCategory("");
    }
  };
  const handleAddBannerIndustry = () => {
    if (
      newBannerIndustry.trim() &&
      !bannerIndustryNames.includes(newBannerIndustry)
    ) {
      setBannerIndustryNames((prev) => [...prev, newBannerIndustry]);
      setBannerIndustryFilter(newBannerIndustry);
      setNewBannerIndustry("");
    }
  };

  const handleSubmit = (
    values: any,
    { setSubmitting, setErrors, setFieldError }: any,
  ) => {
    console.log("Form values:", values);
    const validationErrors: any = {};

    if (!values.banner_title || values.banner_title.trim() === "") {
      validationErrors.banner_title = "Banner Title is required";
    }

    if (!values.banner_description || values.banner_description.trim() === "") {
      validationErrors.banner_description = "Banner description is required";
    }

    if (!values.banner_imageURL || values.banner_imageURL.trim() === "") {
      validationErrors.banner_imageURL = "Banner Image is required";
      console.log("Banner Image URL:", values.banner_imageURL);
    }

    if (!values.banner_type || values.banner_type.trim() === "") {
      validationErrors.banner_type = "Banner Category Type is required";
    }

    if (!values.banner_subCategory || values.banner_subCategory.trim() === "") {
      validationErrors.banner_subCategory = "Banner Sub Category is required";
    }

    if (
      !values.banner_workIndustry ||
      values.banner_workIndustry.trim() === ""
    ) {
      validationErrors.banner_workIndustry = "Banner Industry is required";
    }

    if (!Array.isArray(values.logo.images)) {
      values.logo.images = [{ url: "", alt: "" }];
    }

    if (
      !values.banner_hashtags ||
      !Array.isArray(values.banner_hashtags) ||
      values.banner_hashtags.length === 0
    ) {
      validationErrors.banner_hashtags = "At least one hashtag is required";
    }
    if (!values.banner_titleUrl || values.banner_titleUrl.trim() === "") {
      validationErrors.banner_titleUrl = "Banner Title URL is required";
    } else if (values.banner_titleUrl.includes("/")) {
      validationErrors.banner_titleUrl =
        "Banner Title URL must not contain '/'";
    }

    if (Object.keys(validationErrors).length > 0) {
      Object.keys(validationErrors).forEach((key) => {
        setFieldError(key, validationErrors[key]);
      });
      setSubmitting(false);
      console.log(validationErrors);

      return;
    }

    try {
      const bannerPayload: any = {
        banner_title: values.banner_title,
        banner_description: values.banner_description,
        banner_type: bannerCategoryFilter || "Graphics Design",
        banner_imageURL: values.banner_imageURL,
        bannerImageAlt: values.bannerImageAlt || "",
        banner_subCategory: values.banner_subCategory,
        banner_workIndustry: values.banner_workIndustry,
        banner_hashtags: values.banner_hashtags || [],
        banner_titleUrl: values.banner_titleUrl,
        banner_metaDescription: values.banner_metaDescription || "",
        banner_metaTitle: values.banner_metaTitle || "",
      };

      if (values.banner_videoURL && values.banner_videoURL.trim() !== "") {
        bannerPayload.banner_videoURL = values.banner_videoURL;
      } else {
        bannerPayload.banner_videoURL = "";
      }
      if (values.banner_thumbUrl && values.banner_thumbUrl.trim() !== "") {
        bannerPayload.banner_thumbUrl = values.banner_thumbUrl;
      } else {
        bannerPayload.banner_thumbUrl = "";
      }
      console.log("Banner Title://///XXX1111/", bannerPayload);

      const component = {
        title: values.title,
        subtitle: values.subtitle,
        description: values.description,
        projectFocus: values.projectFocus,
        heroBanner: values.heroBanner,
        heroBannerAlt: values.heroBannerAlt || "",
        heroBannerThumb: values.heroBannerThumb,
        projectDetails: values.projectDetails,
        overview: values.overview,
        sidebar: values.sidebar,
        problem: values.problem,
        solution: values.solution,
        showcase: values.showcase,
        designVision: values.designVision,
        userFlow: values.userFlow,
        revenue: values.revenue,
        logo: values.logo,
        typography: values.typography,
        colorPalette: values.colorPalette,
        wireFrame: values.wireFrame,
        uiDesign: values.uiDesign,
        slider: values.slider,
        metadata: values.metadata,
      };

      if (bannerData?._id) {
        const data = {
          _id: casestudyData._id,
          payload: component,
        };

        dispatch({
          type: REQUEST_UPDATE_MASTER_CASESTUDY,
          data,
          onSuccess: async (response: any) => {
            console.log("response", response);
            if (refreshData) {
              refreshData();
            }
            try {
              const bannerDetailData = {
                caseStydyId: response.data._id,
                banner_title: bannerPayload.banner_title,
                banner_description: bannerPayload.banner_description,
                banner_type: bannerPayload.banner_type || "Graphics Design",
                banner_imageURL: bannerPayload.banner_imageURL,
                bannerImageAlt: bannerPayload.bannerImageAlt,
                banner_subCategory: bannerPayload.banner_subCategory,
                banner_workIndustry: [bannerPayload.banner_workIndustry],
                banner_hashtags: bannerPayload.banner_hashtags,
                banner_titleUrl: bannerPayload.banner_titleUrl,
                banner_metaDescription: bannerPayload.banner_metaDescription,
                banner_metaTitle: bannerPayload.banner_metaTitle,

                ...(bannerData?.serviceId !== null && {
                  serviceId: bannerData.serviceId,
                }),

                ...(bannerPayload.banner_videoURL
                  ? {
                      banner_videoURL: bannerPayload.banner_videoURL,
                    }
                  : {
                      banner_videoURL: "",
                    }),
                ...(bannerPayload.banner_thumbUrl
                  ? {
                      banner_thumbUrl: bannerPayload.banner_thumbUrl,
                    }
                  : {
                      banner_thumbUrl: "",
                    }),
              };

              console.log(
                "bannerPayload.banner_videoURL",
                bannerPayload.banner_videoURL,
                "bannerDetailData for update:",
                bannerDetailData,
              );

              const bannerUpdateResponse = await axios({
                method: "patch",
                url: `${process.env.REACT_APP_BASE_URL}/admin/category/update/${bannerData._id}`,
                data: bannerDetailData,
              });

              console.log("Banner update response:", bannerUpdateResponse);
              dispatch({ type: REQUEST_MASTER_CASESTUDY });
              if (refreshData) {
                refreshData();
              }

              toast({
                title: "Success",
                description: "Case study updated successfully",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-right",
              });

              onClose();
            } catch (error) {
              console.error("Error updating banner:", error);
              toast({
                title: "Error updating banner",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-right",
              });
            }
          },
          onError: (error: any) => {
            console.error("Error updating case study:", error);
            toast({
              title: "Error updating case study",
              description:
                error.response?.data?.[0]?.message || "An error occurred",

              status: "error",
              duration: 3000,
              isClosable: true,
              position: "top-right",
            });
          },
        });
      } else {
        dispatch({
          type: REQUEST_CREATE_MASTER_CASESTUDY,
          payload: component,
          onSuccess: async (response: any) => {
            console.log("response", response);
            if (refreshData) {
              refreshData();
            }

            try {
              const bannerDetailData = {
                caseStydyId: response.data._id,
                banner_title: bannerPayload.banner_title,
                banner_description: bannerPayload.banner_description,
                banner_type: bannerPayload.banner_type || "Graphics Design",
                banner_subCategory: bannerPayload.banner_subCategory,
                banner_workIndustry: [bannerPayload.banner_workIndustry],
                banner_hashtags: bannerPayload.banner_hashtags,
                banner_imageURL: bannerPayload.banner_imageURL,
                bannerImageAlt: bannerPayload.bannerImageAlt,
                banner_thumbUrl: bannerPayload.banner_thumbUrl,
                banner_titleUrl: bannerPayload.banner_titleUrl,
                banner_metaDescription: bannerPayload.banner_metaDescription,
                banner_metaTitle: bannerPayload.banner_metaTitle,

                ...(bannerPayload.banner_videoURL && {
                  banner_videoURL: bannerPayload.banner_videoURL,
                }),
                ...(bannerPayload.banner_thumbUrl && {
                  banner_thumbUrl: bannerPayload.banner_thumbUrl,
                }),
              };

              console.log("bannerDetailData for create:", bannerDetailData);

              const bannerCreateResponse = await axios({
                method: "post",
                url: `${process.env.REACT_APP_BASE_URL}/admin/category/create`,
                data: bannerDetailData,
              });

              console.log("Banner create response:", bannerCreateResponse);
              dispatch({ type: REQUEST_MASTER_CASESTUDY });

              if (refreshData) {
                refreshData();
              }
              toast({
                title: "Success",
                description: "Case study created successfully",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "top-right",
              });

              onClose();
            } catch (error) {
              console.error("Error creating banner:", error);
              toast({
                title: "Error creating banner",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top-right",
              });
            }
          },
          onError: (error: any) => {
            console.error("Error creating case study:", error);
            toast({
              title: "Error creating case study",
              status: "error",
              duration: 3000,
              isClosable: true,
              position: "top-right",
            });
          },
        });
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast({
        title: "Error",
        description: "An unexpected error occurred",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const [showIndustryDescription, setShowIndustryDescription] =
    useState<any>(false);

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="lg">
      <DrawerOverlay />
      <DrawerContent>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ values, errors, touched, setFieldValue, isSubmitting }) => (
            <Form
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <DrawerHeader
                borderBottom="1px solid #E0E0E0"
                background="#f2f2f2"
                alignItems={"stretch"}
                flex="0 0 auto"
              >
                {bannerData ? "Edit" : "Add"} Case Study
              </DrawerHeader>

              <DrawerBody
                flex="1 1 auto"
                overflowY="auto"
                css={{
                  "&::-webkit-scrollbar": {
                    width: "4px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "2px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#555",
                  },
                }}
              >
                <VStack spacing={6} width="100%" align="stretch">
                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Banner Information
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Banner Meta Title</FormLabel>
                        <Field
                          as={Input}
                          name="banner_metaTitle"
                          placeholder="Banner Meta Title"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Banner Meta Description</FormLabel>
                        <Field
                          as={Input}
                          name="banner_metaDescription"
                          placeholder="Banner Meta Description"
                        />
                      </FormControl>
                      <FormControl
                        isInvalid={
                          !!errors.banner_title && !!touched.banner_title
                        }
                      >
                        <FormLabel>Banner Title</FormLabel>
                        <Field
                          as={Input}
                          name="banner_title"
                          placeholder="Banner Title"
                        />
                        <FormErrorMessage>
                          {typeof errors.banner_title === "string"
                            ? errors.banner_title
                            : undefined}
                        </FormErrorMessage>
                      </FormControl>
                      <FormControl
                        isInvalid={
                          !!errors.banner_description &&
                          !!touched.banner_description
                        }
                      >
                        <FormLabel>Banner Description</FormLabel>
                        <Field
                          as={Input}
                          name="banner_description"
                          placeholder="Banner Description"
                        />
                        <FormErrorMessage>
                          {typeof errors.banner_description === "string"
                            ? errors.banner_description
                            : undefined}
                        </FormErrorMessage>
                      </FormControl>
                      <FormControl
                        isInvalid={
                          !!errors.banner_type && !!touched.banner_type
                        }
                      >
                        <FormLabel>Banner Category Type</FormLabel>
                        <HStack>
                          <Box flex="1" marginRight={2}>
                            <Select
                              value={values.banner_type || bannerCategoryFilter}
                              onChange={(event: any) => {
                                setBannerCategoryFilter(event.target.value);
                                setFieldValue(
                                  "banner_type",
                                  event.target.value || "Graphics Design",
                                );
                              }}
                              bg="#FFF"
                            >
                              {bannerCategoryNames.map((category) => (
                                <option key={category} value={category}>
                                  {category}
                                </option>
                              ))}
                            </Select>
                            <FormErrorMessage>
                              {typeof errors.banner_type === "string"
                                ? errors.banner_type
                                : undefined}
                            </FormErrorMessage>
                          </Box>
                          {/* <HStack>
                            <Input
                              placeholder="New Category"
                              value={newBannerCategory}
                              onChange={(e: any) =>
                                setNewBannerCategory(e.target.value)
                              }
                              width="150px"
                            />
                            <Button
                              colorScheme="green"
                              size="sm"
                              onClick={handleAddBannerCategory}
                              isDisabled={!newBannerCategory.trim()}
                            >
                              <FiPlus />
                            </Button>
                          </HStack> */}
                        </HStack>
                      </FormControl>
                      <FormControl
                        isInvalid={
                          !!errors.banner_subCategory &&
                          !!touched.banner_subCategory
                        }
                      >
                        <FormLabel>Banner Sub Category Type</FormLabel>
                        <HStack>
                          <Box flex="1" marginRight={2}>
                            <Select
                              value={
                                values.banner_subCategory ||
                                bannerSubCategoryFilter
                              }
                              onChange={(event: any) => {
                                setBannerSubCategoryFilter(event.target.value);
                                setFieldValue(
                                  "banner_subCategory",
                                  event.target.value,
                                );
                              }}
                              bg="#FFF"
                            >
                              {bannerSubCategoryNames.map((category) => (
                                <option key={category} value={category}>
                                  {category}
                                </option>
                              ))}
                            </Select>
                            <FormErrorMessage>
                              {typeof errors.banner_subCategory === "string"
                                ? errors.banner_subCategory
                                : undefined}
                            </FormErrorMessage>
                          </Box>
                          {/* <HStack>
                            <Input
                              placeholder="New Sub Category"
                              value={newBannerSubCategory}
                              onChange={(e: any) =>
                                setNewBannerSubCategory(e.target.value)
                              }
                              width="150px"
                            />
                            <Button
                              colorScheme="green"
                              size="sm"
                              onClick={handleAddBannerSubCategory}
                              isDisabled={!newBannerSubCategory.trim()}
                            >
                              <FiPlus />
                            </Button>
                          </HStack> */}
                        </HStack>
                      </FormControl>
                      <FormControl
                        isInvalid={
                          !!errors.banner_workIndustry &&
                          !!touched.banner_workIndustry
                        }
                      >
                        <FormLabel>Banner Industry</FormLabel>
                        <HStack>
                          <Box flex="1" marginRight={2}>
                            <Select
                              value={bannerIndustryFilter}
                              onChange={(event: any) => {
                                handleIndustryChange(
                                  event.target.value,
                                  setFieldValue,
                                );
                              }}
                              bg="#FFF"
                            >
                              <option value="">Select Industry</option>

                              {bannerIndustryNames.map((industry, index) => (
                                <option
                                  key={index}
                                  title={industry.description}
                                >
                                  <span>{industry.name}</span>
                                </option>
                              ))}
                            </Select>
                            <FormErrorMessage>
                              {typeof errors.banner_workIndustry === "string"
                                ? errors.banner_workIndustry
                                : undefined}
                            </FormErrorMessage>
                          </Box>
                          {/* <HStack>
                            <Input
                              placeholder="New Industry"
                              value={newBannerIndustry}
                              onChange={(e: any) =>
                                setNewBannerIndustry(e.target.value)
                              }
                              width="150px"
                            />
                            <Button
                              colorScheme="green"
                              size="sm"
                              onClick={() =>
                                handleAddNewIndustry(setFieldValue)
                              }
                              isDisabled={!newBannerIndustry.trim()}
                            >
                              <FiPlus />
                            </Button>
                          </HStack> */}
                        </HStack>
                      </FormControl>
                      {selectedIndustryData && (
                        <FormControl
                          mt={4}
                          isInvalid={
                            !!errors.banner_hashtags &&
                            !!touched.banner_hashtags
                          }
                        >
                          <FormLabel>Industry Hashtags</FormLabel>

                          <HStack mb={3}>
                            <Box flex="1" marginRight={2}>
                              <Select
                                placeholder="Select Hashtag"
                                onChange={(event: any) => {
                                  if (event.target.value) {
                                    handleHashtagSelect(
                                      event.target.value,
                                      setFieldValue,
                                    );
                                    event.target.value = "";
                                  }
                                }}
                                bg="#FFF"
                              >
                                {availableHashtags
                                  .filter(
                                    (hashtag) =>
                                      !selectedHashtags.includes(hashtag),
                                  )
                                  .map((hashtag, index) => (
                                    <option key={index} value={hashtag}>
                                      {hashtag}
                                    </option>
                                  ))}
                              </Select>
                            </Box>

                            <HStack>
                              <Input
                                placeholder="New Hashtag"
                                value={newHashtag}
                                onChange={(e: any) =>
                                  setNewHashtag(e.target.value)
                                }
                                width="150px"
                              />
                              <Button
                                colorScheme="blue"
                                size="sm"
                                onClick={handleAddNewHashtag}
                                isDisabled={!newHashtag.trim()}
                              >
                                <FiPlus />
                              </Button>
                            </HStack>
                          </HStack>

                          {selectedHashtags.length > 0 && (
                            <Box>
                              <Text fontSize="sm" mb={2} color="gray.600">
                                Selected Hashtags:
                              </Text>
                              <Wrap>
                                {selectedHashtags.map((hashtag, index) => (
                                  <WrapItem key={index}>
                                    <Tag
                                      size="md"
                                      colorScheme="blue"
                                      borderRadius="full"
                                    >
                                      <TagLabel>{hashtag}</TagLabel>
                                      <TagCloseButton
                                        onClick={() =>
                                          removeSelectedHashtag(
                                            hashtag,
                                            setFieldValue,
                                          )
                                        }
                                      />
                                    </Tag>
                                  </WrapItem>
                                ))}
                              </Wrap>
                            </Box>
                          )}
                          <FormErrorMessage>
                            {typeof errors.banner_hashtags === "string"
                              ? errors.banner_hashtags
                              : undefined}
                          </FormErrorMessage>
                        </FormControl>
                      )}
                      <FormControl
                        isInvalid={
                          !!errors.banner_titleUrl && !!touched.banner_titleUrl
                        }
                      >
                        <FormLabel>Banner Title URL</FormLabel>
                        <Field
                          as={Input}
                          name="banner_titleUrl"
                          placeholder="Banner Title URL"
                          disabled={bannerData._id}
                        />
                        <FormErrorMessage>
                          {typeof errors.banner_titleUrl === "string"
                            ? errors.banner_titleUrl
                            : undefined}
                        </FormErrorMessage>
                      </FormControl>

                      <UploadVideoAndSelectThumbnail
                        label="Banner Video"
                        fieldName="banner_videoURL"
                        currentImage={values.banner_videoURL}
                        setFieldValue={setFieldValue}
                        isVideo={true}
                        enforceImageDimensions={false}
                        isWatermark={false}
                        videoError={errors.banner_videoURL || ""}
                        imageFieldName="banner_thumbUrl"
                        currentImageForThumbnail={values.banner_thumbUrl}
                        bannerData={bannerData}
                      />
                      <FormControl
                        isInvalid={
                          !!errors.banner_imageURL && !!touched.banner_imageURL
                        }
                      >
                        <BannerMediaUploader
                          label="Banner Image"
                          fieldName="banner_imageURL"
                          currentImage={values.banner_imageURL}
                          setFieldValue={setFieldValue}
                          isVideo={false}
                          enforceImageDimensions={false}
                          isWatermark={false}
                          imageError={errors.banner_imageURL || ""}
                          altFieldName="bannerImageAlt"
                          currentAlt={values.bannerImageAlt}
                        />
                        <FormErrorMessage>
                          {typeof errors.banner_imageURL === "string"
                            ? errors.banner_imageURL
                            : undefined}
                        </FormErrorMessage>
                      </FormControl>
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Basic Information
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="title"
                          placeholder="Project Title"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Subtitle</FormLabel>
                        <Field
                          as={Input}
                          name="subtitle"
                          placeholder="Project Subtitle"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Description</FormLabel>
                        <Field
                          as={Textarea}
                          name="description"
                          placeholder="Project Description"
                        />
                      </FormControl>
                      <BannerMediaUploader
                        label="Hero Banner"
                        fieldName="heroBanner"
                        currentImage={values.heroBanner}
                        setFieldValue={setFieldValue}
                        isVideo={false}
                        enforceImageDimensions={false}
                        isWatermark={true}
                        allowBothTypes={true}
                        currentImageForThumbnail={values.heroBannerThumb}
                        altFieldName="heroBannerAlt"
                        currentAlt={values.heroBannerAlt}
                      />
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Project Details
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Industry</FormLabel>
                        <Field
                          as={Input}
                          name="projectDetails.industry"
                          placeholder="Industry"
                        />
                      </FormControl>

                      <FormControl>
                        <FormLabel>Tools</FormLabel>
                        <FieldArray name="projectDetails.tools">
                          {({ push, remove }) => (
                            <>
                              <Box mb={4}>
                                <ImageUploader
                                  label="Upload Tool Image"
                                  fieldName="toolImageTemp"
                                  currentImages={null}
                                  setFieldValue={(field, value) => {
                                    if (value && value.url) {
                                      push({
                                        url: value.url,
                                        alt: value.alt || "",
                                      });
                                      setFieldValue("toolImageTemp", null);
                                    }
                                  }}
                                  maxImages={1}
                                  section="projectDetails"
                                  isWatermark={false}
                                />
                              </Box>
                              <Box mt={2}>
                                {values.projectDetails.tools.map(
                                  (
                                    tool: string | { url?: string; alt?: string },
                                    index: number,
                                  ) => {
                                    const toolData =
                                      typeof tool === "string"
                                        ? { url: tool, alt: "" }
                                        : tool;
                                    if (!toolData?.url) return null;

                                    return (
                                      <Box
                                        key={index}
                                        display="inline-block"
                                        position="relative"
                                        m={1}
                                        borderRadius="md"
                                        overflow="hidden"
                                        border="1px solid"
                                        borderColor="gray.200"
                                        p={2}
                                        verticalAlign="top"
                                      >
                                        <Image
                                          src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${toolData.url}`}
                                          alt={toolData.alt || `Tool ${index + 1}`}
                                          boxSize="80px"
                                          objectFit="contain"
                                        />
                                        <Input
                                          value={toolData.alt || ""}
                                          placeholder="Alt text"
                                          size="sm"
                                          mt={2}
                                          width="120px"
                                          onChange={(e) =>
                                            setFieldValue(
                                              `projectDetails.tools.${index}.alt`,
                                              e.target.value,
                                            )
                                          }
                                        />
                                        <IconButton
                                          aria-label="Remove tool"
                                          icon={<FiX />}
                                          size="sm"
                                          position="absolute"
                                          top={1}
                                          right={1}
                                          colorScheme="red"
                                          borderRadius="full"
                                          onClick={() => remove(index)}
                                        />
                                      </Box>
                                    );
                                  },
                                )}
                              </Box>
                            </>
                          )}
                        </FieldArray>
                      </FormControl>

                      <FormControl>
                        <FormLabel>Project Year</FormLabel>
                        <Field
                          as={Input}
                          name="projectDetails.projectYear"
                          placeholder="Year"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Key Market</FormLabel>
                        <Field
                          as={Input}
                          name="projectDetails.keyMarket"
                          placeholder="KeyMarket"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Live url</FormLabel>
                        <Field
                          as={Input}
                          name="projectDetails.playstoreUrl"
                          placeholder="Live URL"
                        />
                      </FormControl>
                      {bannerCategoryFilter === "Application" && (
                        <FormControl>
                          <FormLabel>Playstore URL</FormLabel>
                          <Field
                            as={Input}
                            name="projectDetails.playstoreUrl"
                            placeholder="Playstore URL"
                          />
                        </FormControl>
                      )}
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Project Focus
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Categories</FormLabel>
                        <FieldArray name="projectFocus.categories">
                          {({ push, remove }) => (
                            <>
                              <HStack>
                                <Input
                                  placeholder="Enter category"
                                  id="category-input"
                                  onChange={(e: any) => {
                                    e.target.dataset.value = e.target.value;
                                  }}
                                />
                                <Button
                                  colorScheme="blue"
                                  onClick={() => {
                                    const input =
                                      document.getElementById("category-input");
                                    if (input && input.dataset.value) {
                                      push(input.dataset.value);
                                      (input as HTMLInputElement).value = "";
                                      input.dataset.value = "";
                                    }
                                  }}
                                >
                                  Add
                                </Button>
                              </HStack>
                              <Box mt={2}>
                                {values.projectFocus.categories.map(
                                  (category: any, index: number) =>
                                    category && (
                                      <Tag
                                        key={index}
                                        borderRadius="full"
                                        variant="solid"
                                        backgroundColor="gray.100"
                                        m={1}
                                        px={3}
                                        py={2}
                                      >
                                        <TagLabel
                                          fontSize={"16px"}
                                          color="#000"
                                        >
                                          {category}
                                        </TagLabel>
                                        <TagCloseButton
                                          color={"#000"}
                                          onClick={() => remove(index)}
                                        />
                                      </Tag>
                                    ),
                                )}
                              </Box>
                            </>
                          )}
                        </FieldArray>
                      </FormControl>
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Overview
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Section Number</FormLabel>
                        <Field
                          as={Input}
                          name="overview.sectionNumber"
                          placeholder="Section Number"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="overview.title"
                          placeholder="Overview Title"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Description</FormLabel>
                        <Field
                          as={Textarea}
                          name="overview.description"
                          placeholder="Overview Description"
                        />
                      </FormControl>
                      <ImageUploader
                        label="Overview Images"
                        fieldName="overview.images"
                        currentImages={values.overview?.images}
                        setFieldValue={setFieldValue}
                        maxImages={IMAGE_LIMITS.overview}
                        section="overview"
                        isWatermark={true}
                      />
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Sidebar
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Industry</FormLabel>
                        <Field
                          as={Input}
                          name="sidebar.industry"
                          placeholder="Sidebar Industry"
                        />
                      </FormControl>

                      {bannerCategoryFilter !== "Graphics" && (
                        <FormControl>
                          <FormLabel>Platform Type</FormLabel>
                          <FieldArray name="sidebar.platform.type">
                            {({ push, remove }) => (
                              <>
                                <HStack>
                                  <Input
                                    placeholder="Enter platform type"
                                    id="platform-type-input"
                                    onChange={(e: any) => {
                                      e.target.dataset.value = e.target.value;
                                    }}
                                  />
                                  <Button
                                    colorScheme="blue"
                                    onClick={() => {
                                      const input = document.getElementById(
                                        "platform-type-input",
                                      );
                                      if (input && input.dataset.value) {
                                        if (
                                          typeof values.sidebar.platform
                                            .type === "string"
                                        ) {
                                          const existingType =
                                            values.sidebar.platform.type;
                                          if (existingType) {
                                            setFieldValue(
                                              "sidebar.platform.type",
                                              [
                                                existingType,
                                                input.dataset.value,
                                              ],
                                            );
                                          } else {
                                            setFieldValue(
                                              "sidebar.platform.type",
                                              [input.dataset.value],
                                            );
                                          }
                                        } else {
                                          push(input.dataset.value);
                                        }

                                        (input as HTMLInputElement).value = "";
                                        input.dataset.value = "";
                                      }
                                    }}
                                  >
                                    Add
                                  </Button>
                                </HStack>
                                <Box mt={2}>
                                  {values?.sidebar?.platform?.type &&
                                    (Array.isArray(values.sidebar.platform.type)
                                      ? values.sidebar.platform.type.map(
                                          (type, index) =>
                                            type && (
                                              <Tag
                                                key={index}
                                                borderRadius="full"
                                                variant="solid"
                                                backgroundColor="gray.100"
                                                m={1}
                                                px={3}
                                                py={2}
                                              >
                                                <TagLabel
                                                  fontSize={"16px"}
                                                  color="#000"
                                                >
                                                  {type}
                                                </TagLabel>
                                                <TagCloseButton
                                                  color={"#000"}
                                                  onClick={() => remove(index)}
                                                />
                                              </Tag>
                                            ),
                                        )
                                      : typeof values.sidebar.platform.type ===
                                          "string" &&
                                        values.sidebar.platform.type && (
                                          <Tag
                                            borderRadius="full"
                                            variant="solid"
                                            backgroundColor="gray.100"
                                            m={1}
                                            px={3}
                                            py={2}
                                          >
                                            <TagLabel
                                              fontSize={"16px"}
                                              color="#000"
                                            >
                                              {values.sidebar.platform.type}
                                            </TagLabel>
                                            <TagCloseButton
                                              color={"#000"}
                                              onClick={() => {
                                                setFieldValue(
                                                  "sidebar.platform.type",
                                                  [],
                                                );
                                              }}
                                            />
                                          </Tag>
                                        ))}
                                </Box>
                              </>
                            )}
                          </FieldArray>
                        </FormControl>
                      )}
                      <FieldArray name="sidebar.whatWeDid">
                        {({ push, remove }: any) => (
                          <VStack spacing={2} align="stretch" w="full">
                            {values.sidebar.whatWeDid.map(
                              (item: string, index: number) => (
                                <HStack key={index}>
                                  <Input
                                    value={item}
                                    onChange={(e: any) => {
                                      const newItems: string[] = [
                                        ...values.sidebar.whatWeDid,
                                      ];
                                      newItems[index] = e.target.value;
                                      setFieldValue(
                                        "sidebar.whatWeDid",
                                        newItems,
                                      );
                                    }}
                                    placeholder="What We Did"
                                  />
                                  <IconButton
                                    icon={<FiTrash2 />}
                                    aria-label="Remove Item"
                                    onClick={() => remove(index)}
                                  />
                                </HStack>
                              ),
                            )}
                            <Button
                              leftIcon={<FiPlus />}
                              onClick={() => push("")}
                            >
                              Add What We Did
                            </Button>
                          </VStack>
                        )}
                      </FieldArray>
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Problem
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Section Number</FormLabel>
                        <Field
                          as={Input}
                          name="problem.sectionNumber"
                          placeholder="Section Number"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="problem.title"
                          placeholder="Problem Title"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Description</FormLabel>
                        <Field
                          as={Textarea}
                          name="problem.description"
                          placeholder="Problem Description"
                        />
                      </FormControl>
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Solution
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Section Number</FormLabel>
                        <Field
                          as={Input}
                          name="solution.sectionNumber"
                          placeholder="Section Number"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="solution.title"
                          placeholder="Solution Title"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Description</FormLabel>
                        <Field
                          as={Textarea}
                          name="solution.description"
                          placeholder="Solution Description"
                        />
                      </FormControl>
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Showcase
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <BannerMediaUploader
                        label="Showcase Media"
                        fieldName="showcase"
                        currentImage={values.showcase}
                        setFieldValue={setFieldValue}
                        isVideo={false}
                        enforceImageDimensions={false}
                        isWatermark={true}
                        allowBothTypes={true}
                        currentImageForThumbnail={values.showcase.thumbUrl}
                        currentAlt={values.showcase?.alt}
                      />
                      {/* <ImageUploader
                        label="Showcase Media"
                        fieldName="showcase"
                        currentImages={values.showcase}
                        setFieldValue={setFieldValue}
                        maxImages={IMAGE_LIMITS.showcase}
                        allowVideo={true}
                        maxVideos={1}
                        section="showcase"
                        isWatermark={true}
                      /> */}
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Design Vision
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Section Number</FormLabel>
                        <Field
                          as={Input}
                          name="designVision.sectionNumber"
                          placeholder="Section Number"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="designVision.title"
                          placeholder="Design Vision Title"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Subtitle</FormLabel>
                        <Field
                          as={Input}
                          name="designVision.subtitle"
                          placeholder="Design Vision Subtitle"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Description</FormLabel>
                        <Field
                          as={Textarea}
                          name="designVision.description"
                          placeholder="Design Vision Description"
                        />
                      </FormControl>
                      {/*multiple upload*/}
                      <ImageUploader
                        label="Design Vision Media"
                        fieldName="designVision.images"
                        currentImages={values.designVision?.images}
                        setFieldValue={setFieldValue}
                        maxImages={IMAGE_LIMITS.designVision}
                        allowVideo={true}
                        maxVideos={1}
                        section="designVision"
                        isWatermark={true}
                        currentImageForThumbnail={
                          values.designVision
                            ? values.designVision?.images?.filter(
                                (image: any) => image._mediaType === "video",
                              )
                            : []
                        }
                      />
                    </VStack>
                  </VStack>
                  {bannerCategoryFilter !== "Graphics" && (
                    <VStack
                      spacing={4}
                      align="stretch"
                      width="100%"
                      p={4}
                      borderWidth="1px"
                      borderRadius="md"
                    >
                      <Heading size="md" fontWeight="bold">
                        User Flow
                      </Heading>
                      <VStack spacing={4} align="stretch">
                        <FormControl>
                          <FormLabel>Section Number</FormLabel>
                          <Field
                            as={Input}
                            name="userFlow.sectionNumber"
                            placeholder="Section Number"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Title</FormLabel>
                          <Field
                            as={Input}
                            name="userFlow.title"
                            placeholder="User Flow Title"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Description</FormLabel>
                          <Field
                            as={Textarea}
                            name="userFlow.description"
                            placeholder="User Flow Description"
                          />
                        </FormControl>
                        <ImageUploader
                          label="User Flow Image"
                          fieldName="userFlow.image"
                          currentImages={values.userFlow?.image || null}
                          setFieldValue={setFieldValue}
                          maxImages={1}
                          section="userFlow"
                          isWatermark={false}
                        />
                      </VStack>
                    </VStack>
                  )}
                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Revenue
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Section Number</FormLabel>
                        <Field
                          as={Input}
                          name="revenue.sectionNumber"
                          placeholder="Section Number"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="revenue.title"
                          placeholder="Revenue Title"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Description</FormLabel>
                        <Field
                          as={Textarea}
                          name="revenue.description"
                          placeholder="Revenue Description"
                        />
                      </FormControl>
                      <ImageUploader
                        label="Revenue Image"
                        fieldName="revenue.image"
                        currentImages={values.revenue?.image || null}
                        setFieldValue={setFieldValue}
                        maxImages={1}
                        section="revenue"
                        isWatermark={false}
                      />
                    </VStack>
                  </VStack>
                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Logo
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Section Number</FormLabel>
                        <Field
                          as={Input}
                          name="logo.sectionNumber"
                          placeholder="Section Number"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="logo.title"
                          placeholder="Logo Title"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Description</FormLabel>
                        <Field
                          as={Textarea}
                          name="logo.description"
                          placeholder="Logo Description"
                        />
                      </FormControl>

                      <ImageUploader
                        label="Logo Video"
                        fieldName="logo.video"
                        currentImages={values.logo?.video}
                        setFieldValue={setFieldValue}
                        maxImages={1}
                        allowVideo={true}
                        maxVideos={1}
                        section="logo"
                        currentImageForThumbnail={
                          values.logo?.video?.thumbUrl
                            ? values.logo.video.thumbUrl
                            : ""
                        }
                      />
                      <ImageUploader
                        label="Logo Images"
                        fieldName="logo.images"
                        currentImages={values.logo?.images}
                        setFieldValue={setFieldValue}
                        maxImages={IMAGE_LIMITS.logo}
                        section="logo"
                        isWatermark={true}
                      />
                      <ImageUploader
                        label="Logo1 Image"
                        fieldName="logo.logo1ImageBanner"
                        currentImages={values.logo?.logo1ImageBanner || null}
                        setFieldValue={setFieldValue}
                        maxImages={1}
                        section="logo"
                        isWatermark={false}
                      />
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Typography
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Section Number</FormLabel>
                        <Field
                          as={Input}
                          name="typography.sectionNumber"
                          placeholder="Section Number"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="typography.title"
                          placeholder="Typography Title"
                        />
                      </FormControl>

                      {/* <FormControl
                        isInvalid={
                          !!errors.banner_workIndustry &&
                          !!touched.banner_workIndustry
                        }
                      >
                        <FormLabel>Banner Industry</FormLabel>
                        <HStack>
                          <Box flex="1" marginRight={2}>
                            <Select
                              value={
                                values.banner_workIndustry ||
                                bannerIndustryFilter
                              }
                              onChange={(event: any) => {
                                setBannerIndustryFilter(event.target.value);
                                setFieldValue(
                                  "banner_workIndustry",
                                  event.target.value
                                );
                              }}
                              bg="#FFF"
                            >
                              {/* {bannerIndustryNames.map((category) => (
                                <option key={category} value={category}>
                                  {category}
                                </option>
                              ))} 
                            </Select>
                            <FormErrorMessage>
                              {typeof errors.banner_workIndustry === "string"
                                ? errors.banner_workIndustry
                                : undefined}
                            </FormErrorMessage>
                          </Box>
                          <HStack>
                            <Input
                              placeholder="New Industry"
                              value={newBannerIndustry}
                              onChange={(e: any) =>
                                setNewBannerIndustry(e.target.value)
                              }
                              width="150px"
                            />
                            <Button
                              colorScheme="green"
                              size="sm"
                              onClick={handleAddBannerIndustry}
                              isDisabled={!newBannerIndustry.trim()}
                            >
                              <FiPlus />
                            </Button>
                          </HStack>
                        </HStack>
                      </FormControl> */}

                      <ImageUploader
                        label="Typography Images"
                        fieldName="typography.images"
                        currentImages={values.typography?.images}
                        setFieldValue={setFieldValue}
                        maxImages={IMAGE_LIMITS.typography}
                        section="typography"
                        isWatermark={false}
                      />
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Color Palette
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Section Number</FormLabel>
                        <Field
                          as={Input}
                          name="colorPalette.sectionNumber"
                          placeholder="Section Number"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="colorPalette.title"
                          placeholder="Color Palette Title"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Description</FormLabel>
                        <Field
                          as={Textarea}
                          name="colorPalette.description"
                          placeholder="Color Palette Description"
                        />
                      </FormControl>

                      <ImageUploader
                        label="Color Palette Image"
                        fieldName="colorPalette.image"
                        currentImages={
                          values.colorPalette?.image
                            ? [values.colorPalette.image]
                            : []
                        }
                        setFieldValue={setFieldValue}
                        maxImages={IMAGE_LIMITS.colorPalette}
                        section="colorPalette"
                        isWatermark={false}
                      />
                    </VStack>
                  </VStack>
                  {bannerCategoryFilter !== "Graphics" && (
                    <VStack
                      spacing={4}
                      align="stretch"
                      width="100%"
                      p={4}
                      borderWidth="1px"
                      borderRadius="md"
                    >
                      <Heading size="md" fontWeight="bold">
                        Wireframe
                      </Heading>
                      <VStack spacing={4} align="stretch">
                        <FormControl>
                          <FormLabel>Section Number</FormLabel>
                          <Field
                            as={Input}
                            name="wireFrame.sectionNumber"
                            placeholder="Section Number"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Title</FormLabel>
                          <Field
                            as={Input}
                            name="wireFrame.title"
                            placeholder="Wireframe Title"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Description</FormLabel>
                          <Field
                            as={Textarea}
                            name="wireFrame.description"
                            placeholder="Wireframe Description"
                          />
                        </FormControl>
                        {/*multiple upload*/}

                        <ImageUploader
                          label="Wireframe Image"
                          fieldName="wireFrame.images"
                          currentImages={
                            values.wireFrame?.images
                              ? [values.wireFrame.images]
                              : []
                          }
                          setFieldValue={setFieldValue}
                          maxImages={IMAGE_LIMITS.wireFrame}
                          allowVideo={true}
                          maxVideos={1}
                          section="wireFrame"
                          isWatermark={true}
                          currentImageForThumbnail={
                            values.wireFrame
                              ? values.wireFrame?.images.thumbUrl
                              : ""
                          }
                        />
                      </VStack>
                    </VStack>
                  )}

                  {bannerCategoryFilter !== "Graphics" && (
                    <VStack
                      spacing={4}
                      align="stretch"
                      width="100%"
                      p={4}
                      borderWidth="1px"
                      borderRadius="md"
                    >
                      <Heading size="md" fontWeight="bold">
                        UI Design
                      </Heading>
                      <VStack spacing={4} align="stretch">
                        <FormControl>
                          <FormLabel>Section Number</FormLabel>
                          <Field
                            as={Input}
                            name="uiDesign.sectionNumber"
                            placeholder="Section Number"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Title</FormLabel>
                          <Field
                            as={Input}
                            name="uiDesign.title"
                            placeholder="UI Design Title"
                          />
                        </FormControl>
                        <FormControl>
                          <FormLabel>Description</FormLabel>
                          <Field
                            as={Textarea}
                            name="uiDesign.description"
                            placeholder="UI Design Description"
                          />
                        </FormControl>
                        {/*multiple upload*/}

                        <ImageUploader
                          label="UI Design Screens"
                          fieldName="uiDesign.screens"
                          currentImages={
                            values.uiDesign?.screens
                              ? [values.uiDesign.screens]
                              : []
                          }
                          setFieldValue={setFieldValue}
                          maxImages={IMAGE_LIMITS.uiDesign}
                          allowVideo={true}
                          maxVideos={1}
                          section="uiDesign"
                          isWatermark={true}
                          currentImageForThumbnail={
                            values.uiDesign
                              ? values.uiDesign?.screens?.thumbUrl
                              : ""
                          }
                        />
                      </VStack>
                    </VStack>
                  )}
                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Slider
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Section Number</FormLabel>
                        <Field
                          as={Input}
                          name="slider.sectionNumber"
                          placeholder="Section Number"
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Title</FormLabel>
                        <Field
                          as={Input}
                          name="slider.title"
                          placeholder="Slider Title"
                        />
                      </FormControl>

                      <ImageUploader
                        label="Slider Images"
                        fieldName="slider.screens"
                        currentImages={values.slider?.screens}
                        setFieldValue={setFieldValue}
                        maxImages={IMAGE_LIMITS.slider}
                        section="slider"
                        isWatermark={true}
                      />
                    </VStack>
                  </VStack>

                  <VStack
                    spacing={4}
                    align="stretch"
                    width="100%"
                    p={4}
                    borderWidth="1px"
                    borderRadius="md"
                  >
                    <Heading size="md" fontWeight="bold">
                      Footer
                    </Heading>
                    <VStack spacing={4} align="stretch">
                      <FormControl>
                        <FormLabel>Platform</FormLabel>
                        <Field
                          as={Input}
                          name="metadata.platform"
                          placeholder="Platform"
                        />
                      </FormControl>

                      <FormControl>
                        <FormLabel>Project URL</FormLabel>
                        <Field
                          as={Input}
                          name="metadata.projectUrl"
                          placeholder="Project URL"
                        />
                      </FormControl>

                      <ImageUploader
                        label="Metadata Image"
                        fieldName="metadata.image"
                        currentImages={
                          values.metadata?.image ? [values.metadata.image] : []
                        }
                        setFieldValue={setFieldValue}
                        maxImages={IMAGE_LIMITS.metadata}
                        section="metadata"
                        isWatermark={false}
                      />
                    </VStack>
                  </VStack>
                </VStack>
              </DrawerBody>

              <DrawerFooter
                borderTopWidth="1px"
                flex="0 0 auto"
                bg="white"
                position="sticky"
                bottom={0}
                zIndex={1}
              >
                <Button
                  variant="outline"
                  mr={3}
                  border="1px solid #EEE"
                  borderRadius="6px"
                  color="#424242"
                  fontSize={"sm"}
                  onClick={onClose}
                  type="button"
                >
                  Cancel
                </Button>
                <Button
                  colorScheme="blue"
                  type="submit"
                  isLoading={false}
                  background="#000"
                  fontSize={"sm"}
                  color="#fff"
                  _hover={{ background: "#000" }}
                >
                  {bannerData ? "Update" : "Create"} Case Study
                </Button>
              </DrawerFooter>
            </Form>
          )}
        </Formik>
      </DrawerContent>
    </Drawer>
  );
};

export default CasestudyEditDrawer;
